import React, { useEffect, useState } from "react";
import { AWS_BASE_URL, downloadURL, FORM_DATE_TIME_FORMAT, IMAGE_URL, STUDENT_FILE_DOWNLOAD, TABLE_DATE_TIME_FORMAT } from "../../../../utils/Constants";
import PermissionsGate from "../../../../utils/permissionGate";
import { InitialRender, convertToPlain } from "../../../common/Helper";
import { Link, useHistory, useParams, Prompt } from "react-router-dom";
import Swal from "sweetalert2";
import { TrimText } from "../../../common/TrimText";
import { AddAndGetTicketComment, DeleteAssessmentSubmissionUpload, DownloadAssessmentsStudentResults, GetAssessmentSubmissionResults, GetdownloadAssements, GetimportMarks, GetMarkasCompelete, resetSubmissionTotalMark, SendAssignmentInstruction, UpdateHybridMarks, UpDateMarkssubmit, updateSubmissionMarks, UploadMarkAssessment } from "../../../../services/CourseService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ApproveOrDeclineAppeal, ViewAppeal } from "../../../../services/AppealsService";
import moment from "moment";
import Hover from "../../../common/Hover";
import { useFormik } from "formik";
import * as Yup from "yup";
import $ from "jquery"
import Select from "react-select"
import JSZip from "jszip";
import { saveAs } from 'file-saver';
import { useRef } from 'react';
import { twoDecimalRound } from "../../../../utils/commonFunction";
import DataTableComponentFrontPagination from "../../../common/DataTableComponentFrontPagination";
import { RenderQuizResult, RenderSubmissionAndResultStatus } from "../../../../utils/CommonStatusItems";
import { RenderResult, RenderSubmissionStatus } from "../../../../utils/CommonGroupingItem";
import PopupComponent from "../../../common/PopupComponent";
import { useSelector } from "react-redux";
import axios from "axios";
import { FilePond } from "react-filepond";
import "filepond/dist/filepond.min.css";
import * as XLSX from "xlsx";
import SkeletonTicketList from "../../../../loaders/SkeletonTicketList";
import GradeBookSaveBar from "../../../common/GradeBookSaveBar";
import hasPermission from "../../../../utils/hasMultiplePermission";
import { handleUploadToS3BucketUrl } from "../../../common/uploadTOS3BucketUrl";
import DownloadModalComponent from "./DownloadModalComponent";
import { popupSuccessSimple } from "../../../../utils/Popups";

function SubmissionAndResults({assName}) {
  const history = useHistory();
  const { id, subId } = useParams();
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState({ arr: [], checkObj: {} });
  const [submissionStatus, setSubmissionStatus] = useState({ arr: [], checkObj: {} });
  const [linkedCourse , setLinkedCourse] = useState({ arr: [], checkObj: {} });
  const [comment, setComment] = useState("");
  const [deleterow, setDeleteRow] = useState(false);
  const [userData, setUserData] = useState([]);
  const [allUserData , setAllUserData] = useState([])
  const [headerData, setHeaderData] = useState();
  const [courseData,setCourseData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [submissionId, setSubmissionId] = useState();
  const [startDate, setStartDate] = useState(new Date());
  const [studentMessage, setStudentMessage] = useState("");
  const [toggle,setToggle] = useState(false);
  const [studentId, setStudentId] = useState();

  const [appealsDetails, setAppealsDetails] = useState();

  const [disableNeeded, setDisableNeeded] = useState(false);
  const [percent, setPercent] = useState(0);
  const [loaded, setLoaded] = useState(0);
  const [total, setTotal] = useState(0);
  const [checkTotal, setCheckTotal] = useState(0);
  const [checkPending, setCheckPending] = useState(0);
  const [instructionLoading, setInstructionLoading] = useState(false)
  const [checkAssignment, setcheckAssignment] = useState("false")
  const [appealDisable, setAppealDisable] = useState("");
  const [messageError, setMessageError] = useState("")
  const [fileLoading, setFileLoading] = useState(false);
  const [finalTotal, setFinalTotal] = useState(0)
  const [importLoading, setImportLoading] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [updateValueArr, setUpdateValueArr] = useState([]);
  const [saveGradesLoading, setSaveGradesLoading] = useState(false);
  const [options, setOptions] = useState([
    { label: 'Red', value: '0' },
    { label: 'Yellow', value: '49' },
    { label: 'Green', value: '100' },
  ])
  const [updatedata, setupDatedata] = useState(false);
  const [loading, setLoading] = useState(false);
  const [gearid, setGearid] = useState("")
  const [hGear, setHGear] = useState("")
  const [notificationval, setNotificationVal] = useState(false)
  const [downloadZip, setDownloadZip] = useState([])
  const inputRef = useRef(null);
  const [zipfileupload, setZipFileUpload] = useState("")
  const [zipfilename, setZipFileName] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [isSubmissionMarked, setIsSubmissionMarked] = useState(false);
  const [FinalLoadedData, setFinalLoadedData] = useState(0)
  const [isHybrid, setIsHybrid] = useState(false);
  const [isSaveGradesDisabled, setIsSaveGradesDisabled] = useState(false);
  const [filterData , setFilterData] = useState({
    intakeFilters : [],
    submissionStatusFilters : [],
    studentsStatusFilters : [],
    qualificationFilters : []
  });
  const downloadRef = React.useRef(null);
  
  // Get user permissions from Redux store
  const givenPermissions = useSelector((state) => state.givenPermission);

  // Helper function to check if user has permission
  const hasCastEditPermission = () => {
    const permissions = [];
    Object.keys(givenPermissions).forEach((key) => {
      permissions.push(givenPermissions[key]);
    });
    return permissions.includes("castedit");
  };

  const downloadRef2 = React.useRef(null);
  const givenPermsisions = useSelector((state) => state.givenPermission);
  const safeFileName = (path) => {
  if (!path || typeof path !== "string") return null;      // nothing to split
  return path.split("/").pop().trim().replace(/[\t\r\n]/g, "");
};
  useEffect(() => {
    $(document).ready(function () {
      $(".dropdown-toggle").click(function () {
        $('.rdt_TableCell').css('z-index', 0)
        $(this).parents('.rdt_TableCell').css('z-index', 22)
      });
    });
  })
  useEffect(() => {
    let response = hasPermission({ scopes: ["casubmissionresultview"], permissions: givenPermsisions });
    if (!response) {
      history.push("/noaccess");
    }
  }, [])

  const fetchAssessmentData = () => {
    setIsLoading(true);
    GetAssessmentSubmissionResults(subId, id)
      .then((res) => {
        let tempStatus = false;
        const hybridRecord = res.data.body.filter(item => (item.isHybrid == true))
        if (hybridRecord.length) {
          setIsHybrid(true);
          if (hybridRecord.filter(element => element.submission_status != "MARKED").length) {
            tempStatus = true;
          }
        } else if (res.data.body.filter(item => ((item.submission_status == "SUBMITTED" && !item.mark))).length) {
          tempStatus = true;
        }
        setIsSubmissionMarked(tempStatus)
        setUserData(res?.data?.body);
        let data = JSON.parse(JSON.stringify(res?.data?.body))
        setAllUserData(data)
        const updatedMarks = res?.data?.body?.map(item => item?.assTotaleMarkUpdate);
        setIsSaveGradesDisabled(updatedMarks);
        setHeaderData(res?.data?.header);
        setCourseData(res?.data?.courseDetails)
        setIsLoading(false);
        setFilterData({
          ...filterData,
          intakeFilters : res?.data?.intakeFilters,
          submissionStatusFilters : res?.data?.submissionStatusFilters,
          studentsStatusFilters : res?.data?.studentsStatusFilters,
          qualificationFilters : res?.data?.qualificationFilters
        })
      })
      .catch((err) => {
        setIsLoading(false);
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.response.data.message,
        })
      }).finally(() => { setLoading(false); });
  }
  
  useEffect(() => {
    fetchAssessmentData();
  }, [deleterow, updatedata, importLoading]);

  const getSubmissionData = () =>{
    GetAssessmentSubmissionResults(subId, id)
      .then((res) => {
        let tempStatus = false;
        const hybridRecord = res.data.body.filter(item => (item.isHybrid==true))
        if(hybridRecord.length){
          setIsHybrid(true);
          if(hybridRecord.filter(element => element.submission_status!="MARKED").length){
            tempStatus = true;
          }
        }else if(res.data.body.filter(item=>((item.submission_status == "SUBMITTED" && !item.mark))).length){
          tempStatus = true;
        }
        let data = JSON.parse(JSON.stringify(res?.data?.body))
        setAllUserData(data)
        setIsSubmissionMarked(tempStatus)
        setUserData(res?.data?.body);
        setHeaderData(res?.data?.header);   
        setCourseData(res?.data?.courseDetails)
      })
      .catch((err) => {
        console.error(err);
      })
  }


  useEffect(() => {
    GetdownloadAssements(subId, id)
      .then((res) => {
        setDownloadZip(res?.data?.assignment_details)
        setZipFileName(res.data.assignments_codes.name)
      }).catch((err) => {
      })
  }, [updatedata,deleterow])

  const dataToRender = () => {
    let updatedData = [];
    let allData = userData;
    if (search.length) {
      let tempId = allData.filter((item) => {
        let includes = item.id && item.id.toString().includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });
      let tempname = allData.filter((item) => {
        let includes = item.name && item.name.toLowerCase().includes(search.toLowerCase());
        if (includes) {
          return includes;
        } else return null;
      });

      let data = [...tempId, ...tempname];
      let unique = [...new Set(data)];

      updatedData = unique;
    } else {
      updatedData = allData;
    }

    if (status.arr.length) {
      let tempStatus = updatedData;
      let tempResult = tempStatus.filter((item) => {
        const startsWith = status.arr.find(function (post, index) {
          if (item.status && post.toLowerCase() == item.status.toLowerCase() ? item.status : "") return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });

      updatedData = tempResult;
    }

    if (submissionStatus.arr.length) {
      let tempStatus = updatedData;
      let tempResult = tempStatus.filter((item) => {
        const startsWith = submissionStatus.arr.find(function (post, index) {
          if (item.submission_status && post.toLowerCase() == item.submission_status.toLowerCase() ? item.submission_status : "") return item;
        });
        if (startsWith) {
          return startsWith;
        } else return null;
      });

      updatedData = tempResult;
    }

    if (linkedCourse.arr.length) {
      let tempStatus = updatedData;
      let tempResult = tempStatus.filter((item) => {
        const startsWith = linkedCourse.arr.find((post, index) => item.linkedCourseId && post == item.linkedCourseId);
        if (startsWith) {
          return startsWith;
        } else return null;
      });

      updatedData = tempResult;
    }

    if (status.arr.length || search.length || submissionStatus.arr.length || linkedCourse.arr.length) {
      return updatedData;
    } else {
      return userData;
    }
  };

  const addFileFun = async (e, row) => {
    let tempUserData = userData;
    const data = new FormData();
    const listFile = e.target.files;
    let fileSize = [];
    setFileLoading(row?.attempt_id);
    data.append("submission", row?.id);
    data.append("attempt_id", row?.attempt_id);  
    const randomString = Math.random().toString(36).slice(2, 7);
    let awsFileUpload = [];
    const filesArray = Array.from(listFile);
    filesArray.forEach((file, index) => {
      const filePath = `Students/${row?.quiz_student_id}_${row?.student_crm_id}_${row?.first_name}_${row?.last_name}/${subId}_${zipfilename}/${zipfilename}_${row?.student_crm_id}_${new Date().getTime()}_${Math.random().toString(36).slice(2, 7)}.${file?.name?.split(".").pop()}`
      awsFileUpload.push({
        file_type: file?.type,
        file_name: filePath
      });
      fileSize.push(file?.size);
    })
    const uploadedData = await handleUploadToS3BucketUrl(awsFileUpload, filesArray)
    uploadedData.forEach((d, i) => {
      data.append(`files[${i}]`, d.path);
      data.append(`size[${i}]`, fileSize[i])
    })
    
    UploadMarkAssessment(data)
      .then((res) => {        
        getSubmissionData()
      })
      .catch((err) => {
        console.error("error :", err);
      }).finally(()=>{
        setFileLoading("")
      });
    tempUserData.map((item) => {
      if (item?.attempt_id == row?.attempt_id) {
        item.fileName = filesArray.map(file => file.name);
        item.file = e?.target?.files;
        return item;
      } else {
        return item;
      }
    });

    setUserData((tempUserData) => [...tempUserData]);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Only allow drag over if user has permission
    if (!hasCastEditPermission()) {
      e.dataTransfer.dropEffect = 'none';
    }
  };

  const handleDrop = async (e, row) => {
    e.preventDefault();
    e.stopPropagation();

    // Check if user has permission to upload files
    if (!hasCastEditPermission()) {
      Swal.fire({
        title: "Permission Denied",
        text: "You don't have permission to upload files.",
        icon: "error",
        confirmButtonText: "OK",
        timer: 3000,
      });
      return;
    }

    const files = e.dataTransfer.files;
    if (!files || files.length === 0) return;

    let tempUserData = userData;
    const data = new FormData();
    let fileSize = [];
    setFileLoading(row?.id);
    data.append("submission", row?.id);
    setFileLoading(row?.id);
    let awsFileUpload = [];
    const filesArray = Array.from(files);

    filesArray.forEach((file, index) => {
      const filePath = `Students/${row?.quiz_student_id}_${row?.student_crm_id}_${row?.first_name}_${row?.last_name}/${subId}_${zipfilename}/${zipfilename}_${row?.student_crm_id}_${new Date().getTime()}_${Math.random().toString(36).slice(2, 7)}.${file?.name?.split(".").pop()}`
      awsFileUpload.push({
        file_type: file?.type,
        file_name: filePath
      });
      fileSize.push(file?.size);
    });

    const uploadedData = await handleUploadToS3BucketUrl(awsFileUpload, filesArray)
    uploadedData.forEach((d, i) => {
      data.append(`files[${i}]`, d.path);
      data.append(`size[${i}]`, fileSize[i])
    });

    UploadMarkAssessment(data)
      .then((res) => {
        getSubmissionData()
      })
      .catch((err) => {
        console.error("error :", err);
      }).finally(() => {
        setFileLoading("")
      });

    tempUserData.map((item) => {
      if (item.id == row?.id) {
        item.fileName = filesArray.map(file => file.name);
        item.file = files;
        return item;
      } else {
        return item;
      }
    });

    setUserData((tempUserData) => [...tempUserData]);
  };

  const handleSort = (key) =>{
    setToggle(!toggle)
  }

  useEffect(() => {
    setToggle(!toggle)
  },[status,submissionStatus,search])

  const updateSingleGrademix = async (data) => {
    const inputValue = parseFloat(data.ass_mark);
    const totalMark = parseFloat(data?.ass_total_mark);
    if (inputValue > totalMark) {
      setErrorMessage(`Mark cannot exceed total mark of ${totalMark}`);
      setGearid(data.attempt_id);
      return;
    }

    // Clear error if valid
    setErrorMessage("");
    setGearid(null);

    // Your existing grade update logic here
    // ...
  
    const checkGrade = updateValueArr.filter(item => item?.student_id == data?.quiz_student_id)[0]

    let formData
    if (checkGrade) {
       console.log(checkGrade , "checkGrade inside")
       formData = {
        assessment_id: subId,
        intake_id: data?.getGradeSettings?.intake,
        type: 0,
        grademix: [{
          grade: checkGrade?.grade,
          grade_type: checkGrade?.grade_type,
          student_id: checkGrade?.student_id,
          intake: checkGrade?.intake ?? "",
          attempt_id: checkGrade?.attempt_id
        }],
      };
    }else{
       formData = {
        assessment_id: subId,
        intake_id: data?.getGradeSettings?.intake,
        type: 0,
        grademix: [{
          grade: data?.assCalculateGradeStatus?.grade ?? "  ",
          grade_type: data?.getGradeSettings?.grading_type,
          student_id: data?.quiz_student_id ?? "",
          intake: data?.getGradeSettings?.intake ?? "",
          attempt_id: data?.attempt_id
        }],
      };
    }
    try {
      await resetSubmissionTotalMark(formData);
      await Swal.fire({
        icon: "success",
        title: "Success",
        text: "Grade Updated Successfully",
      });
      fetchAssessmentData();
    } catch (error) {
      console.error("Error updating grades:", error);

      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update grades",
      });
      throw error;
    }
  };

  const sortName = (rowA, rowB) => {
    const name1 = rowA.name
      ? rowA.name.toString().toLowerCase().trim()
      : "";
    const name2 = rowB.name
      ? rowB.name.toString().toLowerCase().trim()
      : "";
    return name1.localeCompare(name2);
  }

  const conditionalRowStyles = [
    {
      when: row => row?.assTotaleMarkUpdate == 1 && row?.quiz_id == 0 && (row?.getGradeSettings?.grading_type == 3 || row?.getGradeSettings?.grading_type == 0),
      style: {
        backgroundColor: '#FEF4E8!important',
      },
    },
  ];
  
  const columns = [
    {
      name: "Student",
      selector: "name",
      sortable: true,
      sortFunction: sortName,
      style: row => ({
        backgroundColor: row?.assTotaleMarkUpdate == 0 ? '#FEF4E8' : 'inherit !important',
      }),
      cell: (row) => (
        <div className="assigned-title-block-new">
          <div className="assigned-title-itm">
            <span className={"assigned-title-blk  name-icon cat-dark-red "}>
              {row.image ? <img src={`${IMAGE_URL.replaceAll("http:","https:")}/${encodeURI(row.image.replaceAll("/home/myaie/public_html/", ""))}`} alt="AIE" /> : row.name ? InitialRender([row.name.split(" ")[0], row.name.split(" ")[1]]) : InitialRender(["N", "A"])}
              <span className={`profile-box-2-status ${row.activity_status ? row.activity_status.toLowerCase() == "online" ? "Online" : row.activity_status.toLowerCase() == "away" ? "Away" : "Offline" : "Offline"}`}>
                <i className="fas fa-circle"></i>
              </span>
              <Hover firstName={row.name ? row.name.split(" ")[0] : ""} lastName={row.name ? row.name.split(" ")[1] : ""} photo={row.image} email={row.email} mobile={row.mobile} right={true} role={row.role_name} status={row.status} activity_status={row.activity_status} showNumber={true} number={row.student_crm_id} />
            </span>
            <PermissionsGate scopes={["umedit"]} RenderError={() => <p>{row.name}</p>}>
              <Link title={row.name} className="as-text-blue curser " to={row?.attempt_rid?.rid || row?.submissionCount <=1 ? `/courseAdministration/coursesdetails/${row?.getGradeSettings?.intake}/assessments/open/assigned/submissionsAndResults/${subId}/update/${row?.quiz_student_id}` : `/courseAdministration/assessment/quizzes/open/submissionList/${row?.quiz_id}/${row?.quiz_student_id}?intake_id=${row?.getGradeSettings?.intake}&assess_id=${subId}/attempts/list`}>
                {TrimText(row.name, 15)}
              </Link>
            </PermissionsGate>
          </div>
        </div>
      ),
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
      cell: (row) => row.status ? RenderSubmissionAndResultStatus(row.status).html : "-"
    },
    {
      name: "Submission Status",
      selector: "submission_status",
      sortable: true,
      cell: (row) => {
        return (
          <>
            {row.submission_status ? RenderSubmissionStatus(row.submission_status).html : "-"}
            {((row.student_id != "" && row.student_id != null) || row.appeal_status == "Approved" || row.appeal_status == "Declined") ? (
              <button
                className="btn btn-primary mt-1"
                title="View Appeal"
                data-toggle="modal"
                data-target="#notifications1"
                onClick={() => {
                  setStudentId(row.student_id);
                  handleGetAppealDetails(row.student_id);
                }}
              >
                <i className="fal fa-gavel"></i> View Appeal
              </button>
            ) : ""}
          </>
        )
      }
    },
    { 
      name: "Linked Course", 
      selector: "linkedCourse", 
      sortable: true, 
      cell: (row) => (row.linkedCourse ? <div className="assigned-title-block-new">
        <div className="assigned-title-itm">
            <Link title={row.linkedCourse} className="as-text-blue curser" target="_blank" to={`/courseAdministration/coursesdetails/${row?.getGradeSettings?.intake}/detailCourses/show`}>
              {TrimText(row.linkedCourse, 15)}
            </Link>
        </div>
      </div> : "N/A") 
    },
    { name: "Launch Date", selector: "launchTime", sortable: true, cell: (row) => (row.launchTime ? row.launchTime : "N/A") },
    { name: "Submission Date", selector: "submission_date", sortable: true, cell: (row) => (row.submission_date ? row.submission_date : "N/A") },
    {
      name: "Student Submission",
      selector: "path",
      sortable: true,
      cell: (row) => row.path ?
      <DownloadModalComponent children={
        <p
         data-toggle="modal" data-target="#downloadAssessments"
         className="as-text-blue curser">Download Assignment</p>
      } modalId={'downloadAssessments'} payload={{
             assignmentId : subId,
             student_id : row?.quiz_student_id,
             intake : id
           }} downloadRef={downloadRef} zipName={row?.name + "_" + zipfilename } type={'downloadAssessment'}/>
         : row?.quiz_student_id && row?.quiz_id && row?.submissionCount ? <Link
          title="View Submissions"
          className="as-text-blue curser"
          to={row?.attempt_rid?.rid || row?.submissionCount <=1 ? `/courseAdministration/coursesdetails/${row?.getGradeSettings?.intake}/assessments/open/assigned/submissionsAndResults/${subId}/update/${row?.quiz_student_id}` : `/courseAdministration/assessment/quizzes/open/submissionList/${row?.quiz_id}/${row?.quiz_student_id}?intake_id=${row?.getGradeSettings?.intake}&assess_id=${subId}/attempts/list`}
        >
          View Submissions
        </Link> : "-"
    },
    {
      name: "Results",
      selector: "student_result",
      sortable: false,
      minWidth: "160px !important",
      cell: (row) => ((row?.getGradeSettings?.grading_type == 0 || row?.getGradeSettings?.grading_type == 3) ?
        (
          <div className="input_wt01 resultstatus_flex arrowhide" key={row?.attempt_id}>
            <PermissionsGate scopes={["cassgradeassedit"]} errorProps={{ disabled: true }}>
              <input
                className={`form-control ${(errorMessage && gearid === row.attempt_id) ||
                  (parseFloat(row.ass_mark) > parseFloat(row?.ass_total_mark))
                  ? "is-invalid"
                  : ""
                  }`}
                style={{ width: '100%', maxWidth: '100px' }}
                id={`handleinput${row.attempt_id}`}
                name={`handleinputname${row.attempt_id}`}
                type="number"
                defaultValue={
                  (row.ass_percentage === 0 || row.ass_percentage === null) &&
                    row.mark === null &&
                    updateValueArr.filter(item => item?.student_id === row?.quiz_student_id && item?.intake == row?.getGradeSettings?.intake).length === 0
                    ? ""
                    : (row.ass_mark === "" || row.ass_mark === null)
                      ? row.ass_mark
                      : twoDecimalRound(row.ass_mark)
                }
                onBlur={(e) => {
                  handleUpdateMarks(
                    e.target.value,
                    row.quiz_student_id,
                    "inputbox",
                    row?.ass_total_mark,
                    row,
                    row?.getGradeSettings?.intake
                  );
                }}
                // Disable if grades locked, but NOT if this is supplementary that is not marked as complete
                disabled={(row.lock_grades == 1 && (headerData?.ass_type != 8 || headerData.notify_assessed == 1))}
              />
            </PermissionsGate>
            {errorMessage && gearid === row.id && (
              <div className="invalid-feedback d-block">
                "Please enter a valid mark"
              </div>
            )}

            <span className="pl-1">{"/" + row?.ass_total_mark}</span>
            {loading == true && gearid == row.attempt_id ? <i className="fas fa-cog fa-spin"></i> : ""}
          </div>)
        : (
          row?.getGradeSettings?.grading_type == 1 ?
            (
              <div className="form-icon-group" key={row?.attempt_id}>
                <PermissionsGate scopes={["cassgradeassedit"]} RenderError={() => {
                  return <Select
                    className="form-control custom-select-box wdtcontrlrobot submission-result-dropdown"
                    value={
                      options.find(function (option) {
                        if (row.mark && Number(row.mark.replace(/%\s?/g, '')) >= 0) {
                          return option.value >= Number(row.mark.toString().replace(/%\s?/g, ''))
                        }
                      })
                    }
                    isDisabled={true}
                  />
                }}>

                  <Select
                    className="form-control custom-select-box wdtcontrlrobot submission-result-dropdown"
                    options={options}
                    value={
                      options.find(function (option) {
                        if (row.ass_percentage != null && (row.mark != null || updateValueArr.filter(item => item?.student_id == row?.quiz_student_id && item?.intake == row?.getGradeSettings?.intake).length != 0) && Number(row.ass_percentage.toString().replace(/%\s?/g, '')) >= 0 && (row.ass_percentage.toString().replace(/%\s?/g, '')) !== "") {
                          return option.value >= Number(row.ass_percentage.toString().replace(/%\s?/g, ''))
                        }
                      })
                    }
                    onChange={(value) => {
                      if (value) {
                        handleUpdateMarks(value.value, row.quiz_student_id, "selectbox", row?.ass_total_mark, row, row?.getGradeSettings?.intake)
                      } else {
                        handleUpdateMarks("", row.quiz_student_id, "selectbox", row?.ass_total_mark, row, row?.getGradeSettings?.intake)
                      }
                    }}
                    maxMenuHeight={108}
                    isDisabled={(row.lock_grades == 1 && (headerData?.ass_type != 8 || headerData.notify_assessed == 1))}
                    isClearable
                    menuPosition="fixed"
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                  />
                </PermissionsGate>
                {loading == true && gearid == row.attempt_id ? <span className="flex_wt_loder ml-2"><i className="fas fa-cog fa-spin"></i></span> : ""}
              </div>
            )
            : <div className="form-icon-group" key={row?.attempt_id}>
              <PermissionsGate scopes={["cassgradeassedit"]} RenderError={() => {
                return <Select
                  className="form-control custom-select-box wdtcontrlrobot submission-result-dropdown"
                  isDisabled={true}
                  value={
                    row?.assCalculateGradeStatus?.letterGrades.filter(function (option) {
                      if (row.mark && Number(row.mark.replace(/%\s?/g, '')) >= 0) {
                        return (option.maxValue >= Number(row.mark.replace(/%\s?/g, ''))) && (option.minValue <= Number(row.mark.replace(/%\s?/g, '')))
                      }
                    })
                  }
                />
              }}>
                <Select
                  className="form-control custom-select-box wdtcontrlrobot submission-result-dropdown"
                  options={row?.assCalculateGradeStatus?.letterGrades}
                  value={
                    row?.assCalculateGradeStatus?.letterGrades.filter(function (option) {
                      if (row.ass_percentage != null && (row.mark != null || updateValueArr.filter(item => item?.student_id == row?.quiz_student_id && item?.intake == row?.getGradeSettings?.intake).length != 0) && Number(row?.ass_percentage?.toString()?.replace(/%\s?/g, '')) >= 0 && (row.ass_percentage.toString().replace(/%\s?/g, '')) !== "") {
                        return (option.max_score >= Number(row?.ass_percentage?.toString()?.replace(/%\s?/g, ''))) && (option.min_score <= Number(row?.ass_percentage?.toString()?.replace(/%\s?/g, '')))
                      }
                    })
                  }
                  // isDisabled={true}
                  onChange={(value) => {
                    if (value) {
                      handleUpdateMarks(value.value, row?.quiz_student_id, "selectbox", row?.ass_total_mark, row, row?.getGradeSettings?.intake)
                    } else {
                      handleUpdateMarks("", row?.quiz_student_id, "selectbox", row?.ass_total_mark, row, row?.getGradeSettings?.intake)
                    }
                  }}
                  maxMenuHeight={108}
                  isDisabled={(row.lock_grades == 1 && (headerData?.ass_type != 8 || headerData.notify_assessed == 1))}
                  isClearable
                  menuPosition="fixed"
                  menuPlacement="auto"
                  menuPortalTarget={document.body}
                />
              </PermissionsGate>
              {loading == true && gearid == row.attempt_id ? <span className="flex_wt_loder ml-2"><i className="fas fa-cog fa-spin"></i></span> : ""}
            </div>
        )
      )
    },
    {
      name: "Upload File",
      selector: "",
      cell: (row) => {
        return (
          <div className="frm-group">
            <div 
              className=" atttach-file m-0"
              onDragOver={(e) => handleDragOver(e)}
              onDrop={(e) => handleDrop(e, row)}
            >
              <label>
                {fileLoading==row.id ? <i className="fas fa-cog fa-spin"></i>
                : <i className="fal fa-paperclip"></i>}
                <span>Add Attachment</span>
                <PermissionsGate scopes={["castedit"]} errorProps={{ disabled: true }}>
                  <input disabled={fileLoading == row.id} type="file" multiple className="form-control  form-control-aatch-file" onChange={(e) => addFileFun(e, row)} />
                </PermissionsGate>
              </label>
            </div>
            <ul className="list-unstyled attached-file-ul m-0">
              {row.multipleFiles && row.multipleFiles.filter(item=>item.type==1).map((element, ind)=>(
                <li key={ind}>
                  <a
                    href={
                      element?.path?.startsWith("https://")
                        ? element.path
                        : String(element?.fileUploadedFrom) == '1'
                          ? AWS_BASE_URL + element.path
                          : `${downloadURL}${STUDENT_FILE_DOWNLOAD}/${encodeURI(
                            element.path
                              .replaceAll("/home/myaie/public_html/", "")
                              .replace("public/", "")
                          )}`
                    }
                    target="_blank"
                    download="submission"
                    title={element?.path?.split("/").pop()}
                  >
                    <i className="fal fa-file"></i> {TrimText(element?.path?.split("/").pop(), 15)}
                  </a>
                  <button
                    className="btn btn-danger rounded-circle btn-dropdown-item"
                    title="Delete"
                    onClick={() => {
                      Swal.fire({
                        title: "Are you sure?",
                        text: "You won't be able to revert this!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText:
                          "Yes, delete it!",
                      }).then((result) =>{ 
                        if(result.isConfirmed){
                          DeleteAssessmentSubmissionUpload({ submission_id: element.id, intake: id, type : element.type, submited_type : element.submited_type  }).then(res => {
                            Swal.fire(
                              "Deleted!",
                              "File has been deleted.",
                              "success"
                            );
                            getSubmissionData();
                          }).catch(err => {
                            Swal.fire(
                              "Not Deleted!",
                              "File not deleted.",
                              "error"
                            );
                          })
                        }
                      })
                    }}
                  >
                    <i className="fal fa-trash-alt"></i>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        );
      },
    },
    {
      name: "Mark",
      selector: "mark",
      sortable: true,
      cell: (row) => (
        <div className="flex items-center gap-2" style={{display:'flex',alignItems:'center' ,gap:'5px'}}>
          <span>
            {row.mark && row.showValue ?
              <p className="cat">
                {row?.getGradeSettings?.grading_type == 0 ? `${twoDecimalRound(row.assCalculateGradeStatus.grade)}%`
                  : row?.getGradeSettings?.grading_type == 3 ? `${twoDecimalRound(row.assCalculateGradeStatus?.gradeText)}/${row?.ass_total_mark}`
                    : row.assCalculateGradeStatus?.gradeText}
              </p>
              : headerData?.notify_assessed == 1 ? row?.getGradeSettings?.grading_type == 3 ? `${twoDecimalRound(row.assCalculateGradeStatus?.gradeText)}/${row?.ass_total_mark}` : row.assCalculateGradeStatus.gradeText : <p className="cat">N/A</p>}
          </span>
          {row?.assTotaleMarkUpdate == 1 && (row?.getGradeSettings?.grading_type == 0 || row?.getGradeSettings?.grading_type == 3) && (<i className="fa fa-info-circle text-blue-500" title="Original assessment value is shown. To edit this mark please convert the mark"></i>)}
        </div>
      )
    },
    {
      name: "Action",
      selector: "",
      style: row => ({
        backgroundColor: row?.assTotaleMarkUpdate == 0 ? '#FEF4E8' : 'inherit !important',
      }),
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          {row?.quiz_id && !row.upload_file ? <div className="as-buttons">
            <button
              className="btn btn-primary rounded-circle"
              data-toggle="modal"
              data-target="#notifications"
              onClick={() => {
                handleGetComment(row.id);
                setSubmissionId(row.id);
              }}
              title="Comment"
            >
              <i className="fal fa-comment"></i>
            </button>

            <button
              className="btn btn-primary rounded-circle"
              onClick={() => history.push(`/studentAdministration/students/open/${row.quiz_student_id}/general`)}
              title="Open Student Profile"
            >
              <i className="fal fa-user"></i>
            </button>
          </div> : row?.quiz_id && row.upload_file ? <div className="as-buttons">
              <a className="btn btn-primary rounded-circle" title="Download Submission"
                href={row.upload_file.startsWith('https://') 
                  ? encodeURI(row.upload_file)
                  : String(row?.multipleFiles[0]?.fileUploadedFrom) == '1' ? AWS_BASE_URL + row.upload_file : IMAGE_URL.replaceAll('http:', 'https:') + '/' + encodeURI(row.upload_file)
                } target="_blank" download={"submission"}>
              <i className="fal fa-arrow-down"></i>
            </a>
            <div className="dropdown btn-dropdown-item">
              <button className="btn btn-primary rounded-circle dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i className="fal fa-ellipsis-h-alt"></i>
              </button>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <button
                  className="btn btn-primary rounded-circle"
                  data-toggle="modal"
                  data-target="#notifications"
                  onClick={() => {
                    handleGetComment(row.id);
                    setSubmissionId(row.id);
                  }}
                  title="Comment"
                >
                  <i className="fal fa-comment"></i>
                </button>

                <button
                  className="btn btn-primary rounded-circle"
                  onClick={() => history.push(`/studentAdministration/students/open/${row.quiz_student_id}/general`)}
                  title="Open Student Profile"
                >
                  <i className="fal fa-user"></i>
                </button>
              </div>
            </div>
          </div> : <div className="as-buttons">
            <button
              className="btn btn-primary rounded-circle"
              onClick={() => history.push(`/courseAdministration/coursesdetails/${row?.getGradeSettings?.intake}/assessments/open/assigned/submissionsAndResults/${subId}/update/${row.quiz_student_id}`)}
              title="Open"
            >
              <i className="fal fa-folder-open"></i>
            </button>
            <div className="dropdown btn-dropdown-item">
              <button className="btn btn-primary rounded-circle dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i className="fal fa-ellipsis-h-alt"></i>
              </button>
              
              <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                {row.upload_file && <a className="btn btn-primary rounded-circle" title="Download Submission"
                 href={
                  row?.upload_file?.startsWith('https://')
                    ? encodeURI(row.upload_file)
                    :  String(row?.multipleFiles[0]?.fileUploadedFrom) == '1' ? AWS_BASE_URL + row.upload_file : IMAGE_URL.replace('http:', 'https:') + '/' + encodeURI(row.upload_file)
                }
                 target="_blank" download={"submission"}>
                  <i className="fal fa-arrow-down"></i>
                </a>}

                <button
                  className="btn btn-primary rounded-circle"
                  data-toggle="modal"
                  data-target="#notifications"
                  onClick={() => {
                    handleGetComment(row.id);
                    setSubmissionId(row.id);
                  }}
                  title="Comment"
                >
                  <i className="fal fa-comment"></i>
                </button>

                <button
                  className="btn btn-primary rounded-circle"
                  onClick={() => history.push(`/studentAdministration/students/open/${row.quiz_student_id}/general`)}
                  title="Open Student Profile"
                >
                  <i className="fal fa-user"></i>
                    </button>
                    {(row?.assTotaleMarkUpdate == 1 && row?.quiz_id == 0 && (row?.getGradeSettings?.grading_type == 0 || row?.getGradeSettings?.grading_type == 3)) && (
                      <button
                        className="btn btn-primary rounded-circle"
                        title="Update Mark"
                        disabled={(errorMessage && gearid === row.attempt_id) ||
                          (parseFloat(row.ass_mark) > parseFloat(row?.ass_total_mark))}
                        onClick={() => {
                          updateSingleGrademix(row);
                        }}
                      >
                        <i className="fal fa-redo"></i>
                      </button>
                    )}
              </div>
            </div>
          </div>}
        </div>
      ),
    },
  ]

  const quizColumns = [
    {
      name: "Student",
      selector: "name",
      sortable: true,
      sortFunction: sortName,
      cell: (row) => (
        <div className="assigned-title-block-new">
          <div className="assigned-title-itm">
            <span className={"assigned-title-blk  name-icon cat-dark-red "}>
              {row.image ? <img src={`${IMAGE_URL.replaceAll("http:","https:")}/${row.image.replaceAll("/home/myaie/public_html/", "")}`} alt="AIE" /> : row.name ? InitialRender([row.name.split(" ")[0], row.name.split(" ")[1]]) : InitialRender(["N", "A"])}
              <span className={`profile-box-2-status ${row.activity_status ? row.activity_status.toLowerCase() == "online" ? "Online" : row.activity_status.toLowerCase() == "away" ? "Away" : "Offline" : "Offline"}`}>
                <i className="fas fa-circle"></i>
              </span>
              <Hover firstName={row.name ? row.name.split(" ")[0] : ""} lastName={row.name ? row.name.split(" ")[1] : ""} photo={row.image} email={row.email} mobile={row.mobile} right={true} role={row.role_name} status={row.status} activity_status={row.activity_status} showNumber={true} number={row.student_crm_id} />
            </span>
            <PermissionsGate scopes={["umedit"]} RenderError={() => <p>{row.name}</p>}>
              <Link title={row.name} className="as-text-blue curser " to={row?.attempt_rid?.rid || row?.submissionCount <=1 ? `/courseAdministration/coursesdetails/${row?.getGradeSettings?.intake}/assessments/open/assigned/submissionsAndResults/${subId}/update/${row?.quiz_student_id}` : `/courseAdministration/assessment/quizzes/open/submissionList/${row?.quiz_id}/${row?.quiz_student_id}?intake_id=${row?.getGradeSettings?.intake}&assess_id=${subId}/attempts/list`}>
                {TrimText(row.name, 15)}
              </Link>
            </PermissionsGate>
          </div>
        </div>
      ),
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
      cell: (row) => row.status ? RenderSubmissionAndResultStatus(row.status).html : "-"
    },
    {
      name: "Submission Status",
      selector: "submission_status",
      sortable: true,
      cell: (row) => {
        return (
          <>
            {row.submission_status ? RenderSubmissionStatus(row.submission_status).html : "-"}
            {((row.student_id != "" && row.student_id != null) || row.appeal_status == "Approved" || row.appeal_status == "Declined") ? (
              <button
                className="btn btn-primary mt-1"
                title="View Appeal"
                data-toggle="modal"
                data-target="#notifications1"
                onClick={() => {
                  setStudentId(row.student_id);
                  handleGetAppealDetails(row.student_id);
                }}
              >
                <i className="fal fa-gavel"></i> View Appeal
              </button>
            ) : ""}
          </>
        )
      }
    },
    {
      name: "Linked Course", 
      selector: "linkedCourse", 
      sortable: true, 
      cell: (row) => (row.linkedCourse ? <div className="assigned-title-block-new">
        <div className="assigned-title-itm">
            <Link title={row.linkedCourse} className="as-text-blue curser" target="_blank" to={`/courseAdministration/coursesdetails/${row?.getGradeSettings?.intake}/detailCourses/show`}>
              {TrimText(row.linkedCourse, 15)}
            </Link>
        </div>
      </div> : "N/A") 
    },
    { name: "Launch Date", selector: "launchTime", sortable: true, cell: (row) => (row.launchTime ? row.launchTime : "N/A") },
    { name: "Submission Date", selector: "submission_date", sortable: true, cell: (row) => (row.submission_date ? row.submission_date : "N/A") },
    {
      name: "Student Submission",
      selector: "submissionCount",
      sortable: true,
      cell: (row) => row.path ? <p
        data-toggle="modal" data-target="#downloadAssessment"
        onClick={() => handleStudentDownload(row?.multipleFiles?.length && row.multipleFiles.filter((item)=>(item.type===0)).length ? row.multipleFiles?.filter((item)=>(item?.type===0)) : row)}
        className="as-text-blue curser">Download Assignment</p> : row?.quiz_student_id && row?.quiz_id && row?.submissionCount ? <Link
          title="View Submissions"
          className="as-text-blue curser"
          to={row?.attempt_rid?.rid || row?.submissionCount <=1 ? `/courseAdministration/coursesdetails/${row?.getGradeSettings?.intake}/assessments/open/assigned/submissionsAndResults/${subId}/update/${row?.quiz_student_id}` : `/courseAdministration/assessment/quizzes/open/submissionList/${row?.quiz_id}/${row?.quiz_student_id}?intake_id=${row?.getGradeSettings?.intake}&assess_id=${subId}/attempts/list`}
        >
          View Submissions
        </Link> : "-"
    },
    {
      name: "Student Result",
      selector: "student_result",
      sortable: false,
      minWidth: "160px !important",
      cell: (row) => ((row?.getGradeSettings?.grading_type == 0 || row.getGradeSettings?.grading_type == 3)?
        <div className="input_wt01 resultstatus_flex arrowhide">
          <PermissionsGate scopes={["overidersmart"]}  errorProps={{ disabled: true }}>
            <input             
              className={`form-control ${(errorMessage && gearid === row.attempt_id) ||
                (parseFloat(row.ass_mark) > parseFloat(row?.ass_total_mark))
                ? "is-invalid"
                : ""
              }`}
              max={row?.ass_total_mark}
              type="number"
              defaultValue={(row.ass_percentage == 0 || row.ass_percentage == null) && row.mark == null && updateValueArr.filter(item => item?.student_id == row?.quiz_student_id && item?.intake == row?.getGradeSettings?.intake).length==0 ? row.submited && row.submited != "" ? row.ass_mark ?? "" : "" : (row.ass_mark=="" || row.ass_mark == null)? row.ass_mark : twoDecimalRound(row.ass_mark)}
              onBlur={(e) => handleUpdateMarks(e.target?.value, row.quiz_student_id, "inputbox", row?.ass_total_mark, row, row?.getGradeSettings?.intake)}
              disabled={(row.lock_grades == 1 && (headerData?.ass_type != 8 || headerData.notify_assessed == 1))}
            />
          </PermissionsGate>
          <span className="pl-1">{"/" + row?.ass_total_mark}</span>
        </div> : row?.getGradeSettings?.grading_type == 1 ?
        <div className="form-icon-group">
          <PermissionsGate scopes={["overidersmart"]}  errorProps={{ isDisabled: true }}>
          <Select
            className="form-control custom-select-box wdtcontrlrobot submission-result-dropdown"
            options={options}
            onChange={(value) => {
              if (value){
                handleUpdateMarks(value.value, row?.quiz_student_id, "selectbox", row?.ass_total_mark, row, row?.getGradeSettings?.intake)
              } else {
                handleUpdateMarks("", row?.quiz_student_id, "selectbox", row?.ass_total_mark, row, row?.getGradeSettings?.intake)
              } 
            }}
            isDisabled={(row.lock_grades == 1 && (headerData?.ass_type != 8 || headerData.notify_assessed == 1))}
            value={
              options.find(function (option) {
                if (row.ass_percentage!=null && (row.mark != null || updateValueArr.filter(item => item?.student_id == row?.quiz_student_id && item?.intake == row?.getGradeSettings?.intake).length!=0) && Number(row.ass_percentage.toString().replace(/%\s?/g, ''))>=0 && (row.ass_percentage.toString().replace(/%\s?/g, '')) !== "") {
                  return option.value >= Number(row.ass_percentage.toString().replace(/%\s?/g, ''))
                }
              })
            }
            maxMenuHeight={108}
            isClearable
            menuPosition="fixed"
            menuPlacement="auto"
            menuPortalTarget={document.body}
          />
          </PermissionsGate>
        </div>
        :<div className="form-icon-group">
          <PermissionsGate scopes={["overidersmart"]}  errorProps={{ isDisabled: true }}>
          <Select
            className="form-control custom-select-box wdtcontrlrobot submission-result-dropdown"
            options={row?.assCalculateGradeStatus?.letterGrades}
            value={
              row?.assCalculateGradeStatus?.letterGrades.filter(function (option) {
                if (row.ass_percentage!=null && (row.mark != null || updateValueArr.filter(item => item?.student_id == row?.quiz_student_id && item?.intake == row?.getGradeSettings?.intake).length!=0) && Number(row?.ass_percentage?.toString()?.replace(/%\s?/g, ''))>=0 && (row.ass_percentage.toString().replace(/%\s?/g, '')) !== "") {
                  return (option.max_score >= Number(row?.ass_percentage?.toString()?.replace(/%\s?/g, ''))) && (option.min_score <= Number(row?.ass_percentage?.toString()?.replace(/%\s?/g, '')))
                }
              })
            }
            onChange={(value) => {
              if (value){
                handleUpdateMarks(value.value, row?.quiz_student_id, "selectbox", row?.ass_total_mark, row, row?.getGradeSettings?.intake)
              } else {
                handleUpdateMarks("", row?.quiz_student_id, "selectbox", row?.ass_total_mark, row, row?.getGradeSettings?.intake)
              } 
            }}
            maxMenuHeight={108}
            isDisabled={(row.lock_grades == 1 && (headerData?.ass_type != 8 || headerData.notify_assessed == 1))}
            isClearable
            menuPosition="fixed"
            menuPlacement="auto"
            menuPortalTarget={document.body}
          />
          </PermissionsGate>
        </div>
      )
    },
    {
      name: "Mark",
      selector: "mark",
      sortable: true,
      cell: (row) => 
      (row.mark && row.showValue ?
        <p className="cat">
          {row?.getGradeSettings?.grading_type == 0 ? `${twoDecimalRound(row.assCalculateGradeStatus.grade)}%`
          : row?.getGradeSettings?.grading_type == 3 ? `${twoDecimalRound(row.assCalculateGradeStatus.gradeText)}/${row?.ass_total_mark}`
          : row?.getGradeSettings?.grading_type == 1 ? RenderResult(row.assCalculateGradeStatus.gradeText).html
          : row.assCalculateGradeStatus.gradeText}
        </p> 
        : headerData?.notify_assessed == 1 ? row.getGradeSettings?.grading_type == 3 ? `${twoDecimalRound(row.assCalculateGradeStatus.gradeText)}/${row?.ass_total_mark}` : row.assCalculateGradeStatus.gradeText : <p className="cat">N/A</p>),
    },
    {
      name: "Action",
      selector: "",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          {row?.quiz_id && !row.upload_file ? <div className="as-buttons">
            <button
              className="btn btn-primary rounded-circle"
              data-toggle="modal"
              data-target="#notifications"
              onClick={() => {
                handleGetComment(row.id);
                setSubmissionId(row.id);
              }}
              title="Comment"
            >
              <i className="fal fa-comment"></i>
            </button>

            <button
              className="btn btn-primary rounded-circle"
              onClick={() => history.push(`/studentAdministration/students/open/${row.quiz_student_id}/general`)}
              title="Open Student Profile"
            >
              <i className="fal fa-user"></i>
            </button>
          </div> : row?.quiz_id && row.upload_file ? <div className="as-buttons">
            <a className="btn btn-primary rounded-circle" title="Download Submission" 
                href={row.upload_file.startsWith('https://')
                  ? encodeURI(row.upload_file)
                  : String(row?.multipleFiles[0]?.fileUploadedFrom) === '1' ? AWS_BASE_URL + row.upload_file : IMAGE_URL.replaceAll('http:', 'https:') + '/' + encodeURI(row.upload_file)
                } target="_blank" download={"submission"}>
              <i className="fal fa-arrow-down"></i>
            </a>
            
            <div className="dropdown btn-dropdown-item">
              <button className="btn btn-primary rounded-circle dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i className="fal fa-ellipsis-h-alt"></i>
              </button>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">

                <button
                  className="btn btn-primary rounded-circle"
                  data-toggle="modal"
                  data-target="#notifications"
                  onClick={() => {
                    handleGetComment(row.id);
                    setSubmissionId(row.id);
                  }}
                  title="Comment"
                >
                  <i className="fal fa-comment"></i>
                </button>

                <button
                  className="btn btn-primary rounded-circle"
                  onClick={() => history.push(`/studentAdministration/students/open/${row.quiz_student_id}/general`)}
                  title="Open Student Profile"
                >
                  <i className="fal fa-user"></i>
                </button>
              </div>
            </div>
          </div> : <div className="as-buttons">
            <button
              className="btn btn-primary rounded-circle"
              onClick={() => history.push(`/courseAdministration/coursesdetails/${row?.getGradeSettings?.intake}/assessments/open/assigned/submissionsAndResults/${subId}/update/${row.quiz_student_id}`)}
              title="Open"
            >
              <i className="fal fa-folder-open"></i>
            </button>
            <div className="dropdown btn-dropdown-item">
              <button className="btn btn-primary rounded-circle dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i className="fal fa-ellipsis-h-alt"></i>
              </button>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                {row.upload_file && <a className="btn btn-primary rounded-circle" title="Download Submission" 
                   href={
                    row?.upload_file?.startsWith("https://")
                      ? encodeURI(row.upload_file)
                      : String(row?.multipleFiles[0]?.fileUploadedFrom) == '1' ? AWS_BASE_URL + row.upload_file : IMAGE_URL.replace("http:", "https:") + '/' + encodeURI(row.upload_file)
                  }
                  target="_blank" download={"submission"}>
                  <i className="fal fa-arrow-down"></i>
                </a>}
                

                <button
                  className="btn btn-primary rounded-circle"
                  data-toggle="modal"
                  data-target="#notifications"
                  onClick={() => {
                    handleGetComment(row.id);
                    setSubmissionId(row.id);
                  }}
                  title="Comment"
                >
                  <i className="fal fa-comment"></i>
                </button>

                <button
                  className="btn btn-primary rounded-circle"
                  onClick={() => history.push(`/studentAdministration/students/open/${row.quiz_student_id}/general`)}
                  title="Open Student Profile"
                >
                  <i className="fal fa-user"></i>
                </button>
              </div>
            </div>
          </div>}
        </div>
      ),
    },
  ]

  const hybridColumns = [
    {
      name: "Student",
      selector: "name",
      sortable: true,
      sortFunction: sortName,
      // minWidth: "190px",
      cell: (row) => (
        <div className="assigned-title-block-new">
          <div className="assigned-title-itm">
            <span className={"assigned-title-blk  name-icon cat-dark-red "}>
              {row.image ? <img src={`${IMAGE_URL.replaceAll("http:","https:")}/${encodeURI(row.image.replaceAll("/home/myaie/public_html/", ""))}`} alt="AIE" /> : row.name ? InitialRender([row.name.split(" ")[0], row.name.split(" ")[1]]) : InitialRender(["N", "A"])}
              <span className={`profile-box-2-status ${row.activity_status ? row.activity_status.toLowerCase() == "online" ? "Online" : row.activity_status.toLowerCase() == "away" ? "Away" : "Offline" : "Offline"}`}>
                <i className="fas fa-circle"></i>
              </span>
              <Hover firstName={row.name ? row.name.split(" ")[0] : ""} lastName={row.name ? row.name.split(" ")[1] : ""} photo={row.image} email={row.email} mobile={row.mobile} right={true} role={row.role_name} status={row.status} activity_status={row.activity_status} showNumber={true} number={row.student_crm_id} />
            </span>
            <PermissionsGate scopes={["umedit"]} RenderError={() => <p>{row.name}</p>}>
              <Link title={row.name} className="as-text-blue curser " to={row?.attempt_rid?.rid || row?.submissionCount <=1 ? `/courseAdministration/coursesdetails/${row?.getGradeSettings?.intake}/assessments/open/assigned/submissionsAndResults/${subId}/update/${row?.quiz_student_id}` : `/courseAdministration/assessment/quizzes/open/submissionList/${row?.quiz_id}/${row?.quiz_student_id}?intake_id=${row?.getGradeSettings?.intake}&assess_id=${subId}/attempts/list`}>
                {TrimText(row.name, 15)}
              </Link>
            </PermissionsGate>
          </div>
        </div>
      ),
    },
    {
      name: "Status",
      selector: "status",
      sortable: true,
      cell: (row) => row.status ? RenderSubmissionAndResultStatus(row.status).html : "-"
    },
    {
      name: "Submission Status",
      selector: "submission_status",
      sortable: true,
      cell: (row) => {
        return (
          <>
            {row.submission_status ? RenderSubmissionStatus(row.submission_status).html : "-"}
            {((row.student_id != "" && row.student_id != null) || row.appeal_status == "Approved" || row.appeal_status == "Declined") ? (
              <button
                className="btn btn-primary mt-1"
                title="View Appeal"
                data-toggle="modal"
                data-target="#notifications1"
                onClick={() => {
                  setStudentId(row.student_id);
                  handleGetAppealDetails(row.student_id);
                }}
              >
                <i className="fal fa-gavel"></i> View Appeal
              </button>
            ) : ""}
          </>
        )
      }
    },
    {
      name: "Linked Course", 
      selector: "linkedCourse", 
      sortable: true, 
      cell: (row) => (row.linkedCourse ? <div className="assigned-title-block-new">
        <div className="assigned-title-itm">
            <Link title={row.linkedCourse} className="as-text-blue curser" target="_blank" to={`/courseAdministration/coursesdetails/${row?.getGradeSettings?.intake}/detailCourses/show`}>
              {TrimText(row.linkedCourse, 15)}
            </Link>
        </div>
      </div> : "N/A") 
    },
    { name: "Launch Date", selector: "launchTime", sortable: true, cell: (row) => (row.launchTime ? row.launchTime : "N/A") },
    { name: "Submission Date", selector: "submission_date", sortable: true, cell: (row) => (row.submission_date ? row.submission_date : "N/A") },
    {
      name: "Student Submission",
      selector: "submissionCount", 
      sortable: true,
      cell: (row) => row.path ? <p
        data-toggle="modal" data-target="#downloadAssessment"
        onClick={() => handleStudentDownload(row?.multipleFiles?.length && row.multipleFiles?.filter((item)=>(item.type===0)).length ? row.multipleFiles?.filter((item)=>(item?.type===0)) : row)}
        className="as-text-blue curser">Download Assignment</p> : row?.quiz_student_id && row?.quiz_id && row?.submissionCount ? <Link
          title="View Submissions"
          className="as-text-blue curser"
          to={row?.attempt_rid?.rid || row?.submissionCount <=1 ? `/courseAdministration/coursesdetails/${row?.getGradeSettings?.intake}/assessments/open/assigned/submissionsAndResults/${subId}/update/${row?.quiz_student_id}` : `/courseAdministration/assessment/quizzes/open/submissionList/${row?.quiz_id}/${row?.quiz_student_id}?intake_id=${row?.getGradeSettings?.intake}&assess_id=${subId}/attempts/list`}
        >
          View Submissions
        </Link> : "-"
    },
    {
      name: "Hybrid Results",
      selector: "student_result",
      sortable: false,
      minWidth: "160px !important",
      cell: (row) => ((row?.getGradeSettings?.grading_type == 0 || row?.getGradeSettings?.grading_type == 3) ?
        <div className="input_wt01 resultstatus_flex arrowhide">
          <PermissionsGate scopes={["cassgradeassedit"]} errorProps={{ disabled: true }}>
            <input
              disabled
              className={"form-control" + (errorMessage && hGear == row.id ? " is-invalid" : "")}
              type="number"
              defaultValue={(row.mark!="" && row.mark!=null) && row.hybrid_marks>=0 && row.hybrid_marks !== null ? row.hybrid_marks : "-"}
              onBlur={(e) => handleHybridResultChange(e, row.id, "inputbox", row.hybirdQuestionScore)}
            />
          </PermissionsGate>
          <span className="pl-1">{"/" + row.hybirdQuestionScore}</span>
          {loading == true && hGear == row.id ? <i className="fas fa-cog fa-spin"></i> : ""}
        </div> : row?.getGradeSettings?.grading_type == 1 ?
        <div className="form-icon-group">
          <Select
            className="form-control custom-select-box wdtcontrlrobot"
            options={options}
            isDisabled={true}
            value={
              options.filter(function (option) {
                if (row.hybirdMarksPerchange>=0) {
                  return option.value >= (row.hybirdMarksPerchange == null ? null : Math.round(row.hybirdMarksPerchange))
                }
              })
            }
            onChange={(e) => handleHybridResultChange(e, row.id, "selectbox", row.hybirdQuestionScore)}
            isClearable
            menuPosition="fixed"
            menuPlacement="auto"
            menuPortalTarget={document.body}
          />
          {loading == true && hGear == row.id ? <span className="flex_wt_loder ml-2"><i className="fas fa-cog fa-spin"></i></span> : ""}
        </div>
        :<div className="form-icon-group">
        <Select
          className="form-control custom-select-box wdtcontrl"
          options={row?.assCalculateGradeStatus?.letterGrades}
          isDisabled={true}
            value={
              row?.assCalculateGradeStatus?.letterGrades.filter(function (option) {
              if (row.hybirdMarksPerchange>=0) {
                return (option.max_score >= Math.round(row.hybirdMarksPerchange)) && (option.min_score <= Math.round(row.hybirdMarksPerchange))
                }
              })
            }
          onChange={(e) => handlegradeChange(e, row.id, "selectbox", row?.ass_total_mark, row)
          }
          menuPosition="fixed"
          menuPlacement="auto"
          menuPortalTarget={document.body}
        />
        {loading == true && gearid == row.attempt_id ? <span className="flex_wt_loder ml-2"><i className="fas fa-cog fa-spin"></i></span> : ""}
      </div>
      )
    },
    {
      name: "Smart Results",
      selector: "student_result",
      sortable: false,
      minWidth: "160px !important",
      cell: (row) => ((row?.getGradeSettings?.grading_type == 0 || row?.getGradeSettings?.grading_type == 3) ?
        <div className="input_wt01 resultstatus_flex arrowhide">
          <PermissionsGate scopes={["cassgradeassedit"]} errorProps={{ disabled: true }}>
            <input
              disabled
              className={"form-control" + (errorMessage && gearid == row.attempt_id ? " is-invalid" : "")}
              type="number"
              defaultValue={(row.mark!="" && row.mark!=null) && (row.ass_normal_marks != null && row.ass_normal_marks>=0) ? twoDecimalRound(row.ass_normal_marks) : ""}
              onBlur={(e) => handlegradeChange(e, row.id, "inputbox", row.totalSmartQuestionScore, row)}
            />
          </PermissionsGate>
          <span className="pl-1">{"/" + row.totalSmartQuestionScore}</span>
          {loading == true && gearid == row.attempt_id ? <i className="fas fa-cog fa-spin"></i> : ""}
        </div> : row?.getGradeSettings?.grading_type == 1 ?
        <div className="form-icon-group">
          <Select
            className="form-control custom-select-box wdtcontrl"
            options={options}
            isDisabled={true}
            value={
              options.filter(function (option) {
                if (row.normalMarksPerchange>=0) {
                  return option.value >= Math.round(row.normalMarksPerchange)
                }
              })
            }
            onChange={(e) => handlegradeChange(e, row.id, "selectbox", row.hybirdQuestionScore,)
            }
            menuPosition="fixed"
            menuPlacement="auto"
            menuPortalTarget={document.body}
          />
          {loading == true && gearid == row.attempt_id ? <span className="flex_wt_loder ml-2"><i className="fas fa-cog fa-spin"></i></span> : ""}
        </div>
        :<div className="form-icon-group">
          <Select
            className="form-control custom-select-box wdtcontrl"
            options={row?.assCalculateGradeStatus?.letterGrades}
            isDisabled={true}
            value={
              row?.assCalculateGradeStatus?.letterGrades.filter(function (option) {
                if (row.normalMarksPerchange>=0) {
                  return (option.max_score >= Math.round(row.normalMarksPerchange)) && (option.min_score <= Math.round(row.normalMarksPerchange))
                }
              })
            }
            onChange={(e) => handlegradeChange(e, row.id, "selectbox", row?.ass_total_mark, row)
            }
            menuPosition="fixed"
            menuPlacement="auto"
            menuPortalTarget={document.body}
          />
          {loading == true && gearid == row.attempt_id ? <span className="flex_wt_loder ml-2"><i className="fas fa-cog fa-spin"></i></span> : ""}
        </div>
      )
    },
    {
      name: "Upload File",
      selector: "",
      cell: (row) => {
        return ( 
          <div className="frm-group">
            <div className=" atttach-file m-0" 
              onDragOver={(e) => handleDragOver(e)}
              onDrop={(e) => handleDrop(e, row)}
              >
              <label>
                {fileLoading==row.id ? <i className="fas fa-cog fa-spin"></i>
                : <i className="fal fa-paperclip"></i>}
                <span>Add Attachment</span>
                <PermissionsGate scopes={["castedit"]} errorProps={{ disabled: true }}>
                  <input disabled={fileLoading == row.id} type="file" multiple className="form-control  form-control-aatch-file" onChange={(e) => addFileFun(e, row)} />
                </PermissionsGate>
              </label>
            </div>

            <ul className="list-unstyled attached-file-ul m-0">
              {row?.multipleFiles && row?.multipleFiles?.filter(item => !item?.inExamWarning)?.map((element, ind)=>(
                <li key={ind}> 
                  <a
                    href={
                      element.path.startsWith("https://")
                        ? encodeURI(element.path)
                        : String(element?.fileUploadedFrom) === "1"
                          ? `${AWS_BASE_URL}${element.path}`
                          : `${downloadURL}${STUDENT_FILE_DOWNLOAD}/${encodeURI(
                            element.path
                              .replaceAll("/home/myaie/public_html/", "")
                              .replace("public/", "")
                          )}`
                    }
                    target="_blank"
                    download="submission"
                    title={element?.path?.split("/").pop()}
                  >
                    <i className="fal fa-file"></i> {TrimText(element?.path?.split("/").pop(), 15)}
                  </a>
                  <button
                    className="btn btn-danger rounded-circle btn-dropdown-item"
                    title="Delete"
                    onClick={() => {
                      Swal.fire({
                        title: "Are you sure?",
                        text: "You won't be able to revert this!",
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText:
                          "Yes, delete it!",
                      }).then((result) => {

                        if(result.isConfirmed){ 
                          DeleteAssessmentSubmissionUpload({ submission_id: element.id, intake: row?.getGradeSettings?.intake, type : element.type, submited_type : element.submited_type, attempt_id : row?.attempt_id }).then(res => {
                            Swal.fire(
                              "Deleted!",
                              "File has been deleted.",
                              "success"
                            );
                            getSubmissionData()
                          }).catch(err => {
                            console.error("error :", err)
                            Swal.fire(
                              "Not Deleted!",
                              "File not deleted.",
                              "error"
                            );
                          })                          
                        }
                      })
                    }}
                  >
                    <i className="fal fa-trash-alt"></i>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        );
      },
    },
    {
      name: "Mark",
      selector: "mark",
      sortable: true,
      cell: (row) => (row.mark && row.showValue ? 
      <p className="cat">
        {row?.getGradeSettings?.grading_type == 0 ? `${twoDecimalRound(row.assCalculateGradeStatus.grade)}%`
        : row?.getGradeSettings?.grading_type == 3 ? `${twoDecimalRound(row.assCalculateGradeStatus.gradeText)}/${row?.ass_total_mark}` 
        : row.assCalculateGradeStatus.gradeText}
      </p> 
      : headerData?.notify_assessed == 1 ? row?.getGradeSettings?.grading_type == 3 ? `${twoDecimalRound(row.assCalculateGradeStatus.gradeText)}/${row?.ass_total_mark}` : row.assCalculateGradeStatus.gradeText : <p className="cat">N/A</p>),
    },
    {
      name: "Action",
      selector: "",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          {row?.quiz_id && !row.upload_file ? <div className="as-buttons">
            <button
              className="btn btn-primary rounded-circle"
              data-toggle="modal"
              data-target="#notifications"
              onClick={() => {
                handleGetComment(row.id);
                setSubmissionId(row.id);
              }}
              title="Comment"
            >
              <i className="fal fa-comment"></i>
            </button>

            <button
              className="btn btn-primary rounded-circle"
              onClick={() => history.push(`/studentAdministration/students/open/${row.quiz_student_id}/general`)}
              title="Open Student Profile"
            >
              <i className="fal fa-user"></i>
            </button>
          </div> : row?.quiz_id && row.upload_file ? <div className="as-buttons">
            <a className="btn btn-primary rounded-circle" title="Download Submission"
              href={row.upload_file.startsWith('https://')
                ? encodeURI(row.upload_file)
                : String(row?.multipleFiles[0]?.fileUploadedFrom) == '1' ? AWS_BASE_URL + row.upload_file : IMAGE_URL.replaceAll('http:', 'https:') + '/' + encodeURI(row.upload_file)
              } target="_blank" download={"submission"}>
              <i className="fal fa-arrow-down"></i>
            </a>
            
            <div className="dropdown btn-dropdown-item">
              <button className="btn btn-primary rounded-circle dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i className="fal fa-ellipsis-h-alt"></i>
              </button>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">

                <button
                  className="btn btn-primary rounded-circle"
                  data-toggle="modal"
                  data-target="#notifications"
                  onClick={() => {
                    handleGetComment(row.id);
                    setSubmissionId(row.id);
                  }}
                  title="Comment"
                >
                  <i className="fal fa-comment"></i>
                </button>

                <button
                  className="btn btn-primary rounded-circle"
                  onClick={() => history.push(`/studentAdministration/students/open/${row.quiz_student_id}/general`)}
                  title="Open Student Profile"
                >
                  <i className="fal fa-user"></i>
                </button>
              </div>
            </div>
          </div> : <div className="as-buttons">
            <button
              className="btn btn-primary rounded-circle"
              onClick={() => history.push(`/courseAdministration/coursesdetails/${row?.getGradeSettings?.intake}/assessments/open/assigned/submissionsAndResults/${subId}/update/${row.quiz_student_id}`)}
              title="Open"
            >
              <i className="fal fa-folder-open"></i>
            </button>
            <div className="dropdown btn-dropdown-item">
              <button className="btn btn-primary rounded-circle dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i className="fal fa-ellipsis-h-alt"></i>
              </button>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                {row.upload_file && <a className="btn btn-primary rounded-circle" title="Download Submission" 
                  href={row.upload_file.startsWith('https://')
                    ? encodeURI(row.upload_file)
                    : String(row?.multipleFiles[0]?.fileUploadedFrom) == '1' ? AWS_BASE_URL + row.upload_file : IMAGE_URL.replaceAll('http:', 'https:') + '/' + encodeURI(row.upload_file)
                  } target="_blank" download={"submission"}>
                  <i className="fal fa-arrow-down"></i>
                </a>}

                <button
                  className="btn btn-primary rounded-circle"
                  data-toggle="modal"
                  data-target="#notifications"
                  onClick={() => {
                    handleGetComment(row.id);
                    setSubmissionId(row.id);
                  }}
                  title="Comment"
                >
                  <i className="fal fa-comment"></i>
                </button>

                <button
                  className="btn btn-primary rounded-circle"
                  onClick={() => history.push(`/studentAdministration/students/open/${row.quiz_student_id}/general`)}
                  title="Open Student Profile"
                >
                  <i className="fal fa-user"></i>
                </button>
              </div>
            </div>
          </div>}
        </div>
      ),
    },
  ];

  const exportData = () => {
    let data = dataToRender();
    let header;
    let pdfData;

    if(headerData && headerData.quiz_id && isHybrid===true){
      header = ["Student", "Status", "Submission Status", "Linked Course", "Launch Date", "Submission Date", "Hybrid Results", "Smart Results", "Mark"];
  
      data = data?.map((row) => ({
        ...row,
        Student: row?.name,
        Status: row?.status,
        "Submission Status": row?.submission_status ? row?.submission_status === 'closednot submitted' ? 'CLOSED-NOT SUBMITTED' : row?.submission_status  : '-',
        "Linked Course": row?.linkedCourse ? row?.linkedCourse : "-",
        "Launch Date": row?.launchTime ? row.launchTime : "-",
        "Submission Date": row?.submission_date ? row?.submission_date : "-",
        "Hybrid Results": (row?.getGradeSettings?.grading_type == 0 || row?.getGradeSettings?.grading_type == 3) ?  (row?.hybrid_marks>=0 && row?.showValue ? Math.round(row?.hybrid_marks) + "/" + row.hybirdQuestionScore : "-") : 
        row?.getGradeSettings?.grading_type == 1 ? (row.hybirdMarksPerchange >=0 ? options.find(function (option) {
          if (row.hybirdMarksPerchange >=0) {
            return option.value >= Math.round(row.hybirdMarksPerchange)
          }
        })?.label : "-") : (row.hybirdMarksPerchange>=0 ? row?.assCalculateGradeStatus?.letterGrades.find(function (option) {
          if (row.hybirdMarksPerchange>=0) {
            return (option.maxValue >= row.hybirdMarksPerchange) && (option.minValue <= row.hybirdMarksPerchange)
          }
        })?.label : "-"),
        "Smart Results": (row?.getGradeSettings?.grading_type == 0 || row?.getGradeSettings?.grading_type == 3) ?  (row.ass_normal_marks>=0 ? Math.round(row.ass_normal_marks) + "/" + row.totalSmartQuestionScore : "-") : 
        row.grade == 1 ? (row.normalMarksPerchange>=0 ? options.find(function (option) {
          if (row.normalMarksPerchange>=0) {
            return option.value >= Math.round(row.normalMarksPerchange)
          }
        })?.label : "-") : (row.normalMarksPerchange>=0 ? row?.assCalculateGradeStatus?.letterGrades.find(function (option) {
          if (row.normalMarksPerchange>=0) {
            return (option.maxValue >= row.normalMarksPerchange) && (option.minValue <= row.normalMarksPerchange)
          }
        })?.label : "-"),
        Mark: row.mark && row.showValue ? (row?.getGradeSettings?.grading_type === 0 ? (row.assCalculateGradeStatus.grade ? `${twoDecimalRound(row.assCalculateGradeStatus.grade)}%` : "-")
        : row?.getGradeSettings?.grading_type === 3 ? (row.assCalculateGradeStatus.gradeText ? `${row.assCalculateGradeStatus.gradeText}/${row?.ass_total_mark}` : "-") 
        : (row.assCalculateGradeStatus.gradeText ? row.assCalculateGradeStatus.gradeText : "-")) : "NA",
      }));
      pdfData = data.map((row) => {
        return [row.Student, row.Status, row["Submission Status"], row["Linked Course"], row["Launch Date"], row["Submission Date"], row["Hybrid Results"], row["Smart Results"], row.Mark];
      });
    }else{
      header = ["Student", "Status", "Linked Course", "Launch Date", "Submission Date", "Submission Status", "Student Result", "Mark"];
  
      data = data?.map((row) => ({
        ...row,
        Student: row?.name,
        Status: row?.status,
        "Linked Course": row?.linkedCourse ? row?.linkedCourse : "-",
        "Launch Date": row?.launchTime ? row.launchTime : "-",
        "Submission Date": row?.submission_date ? row?.submission_date : "-",
        "Submission Status": row?.submission_status ? row?.submission_status === 'closednot submitted' ? 'CLOSED-NOT SUBMITTED' : row?.submission_status  : '-',
        "Student Result": (row?.getGradeSettings?.grading_type == 0 || row?.getGradeSettings?.grading_type == 3) ?  (row.ass_mark ? twoDecimalRound(row.ass_mark) + "/" + row?.ass_total_mark : "-") : 
        row?.getGradeSettings?.grading_type == 1 ? (row.mark ? options.find(function (option) {
          if (row.mark) {
            return option.value === row.mark.toString().replace(/%\s?/g, '')
          }
        })?.label : "-") : (row.mark ? row?.assCalculateGradeStatus?.letterGrades.filter(function (option) {
          if (row.mark) {
            return (option.maxValue >= Number(row.mark.replace(/%\s?/g, ''))) && (option.minValue <= Number(row.mark.replace(/%\s?/g, '')))
          }
        }):"-"),
        Mark: row?.getGradeSettings?.grading_type === 0 ? (row.assCalculateGradeStatus.grade ? `${twoDecimalRound(row.assCalculateGradeStatus.grade)}%` : "-")
        : row?.getGradeSettings?.grading_type === 3 ? (row.assCalculateGradeStatus.gradeText ? `${row.assCalculateGradeStatus.gradeText}/${row?.ass_total_mark}` : "-") 
        : (row.assCalculateGradeStatus.gradeText ? row.assCalculateGradeStatus.gradeText : "-"),
      }));
      pdfData = data.map((row) => {
        return [row.Student, row.Status, row["Linked Course"], row["Launch Date"], row["Submission Date"], row["Submission Status"], row["Student Result"], row.Mark];
      });
    }

    return {
      data,
      header,
      pdfData
    }
  };

  const handleGetComment = (submissionID) => {
    const data = new FormData();
    data.append("assignment_id", subId);
    data.append("stdid", submissionID);
    data.append("action_type", "get_comment");
    AddAndGetTicketComment(data)
      .then((response) => {
        setComment(response.data.comment);
      })
      .catch((error) => {
        console.error("AddAndGetTicketComment error:", error);
      });
  };

  const handleGetAppealDetails = (ID) => {
    setStudentMessage("")
    ViewAppeal(ID, subId)
      .then((res) => {
        setStudentMessage(res.data.student_appeal.student_message);
        if (res.data.student_appeal.appeal_status !== "Approved" && res.data.student_appeal.appeal_status !== "Declined") {
          setStartDate(moment(new Date()).add(3, 'days')._d)
        } else {
          setStartDate(moment.unix(res.data.student_appeal.ass_ext_close_date)._d)
        }
        setAppealsDetails(res.data);
        setDisableNeeded(res.data.student_appeal.ass_status == "Closed-Not Submitted")
      })
      .catch((err) => console.error("err :", err));
  };

  const formik = useFormik({
    initialValues: {
      comment: comment,
    },
    validationSchema: Yup.object({
      comment: Yup.string().required("Assessment Name is required").trim(),
    }),
    onSubmit: (values) => {
      const data = new FormData();
      data.append("comment", values.comment);
      data.append("assignment_id", subId);
      data.append("stdid", submissionId);
      data.append("action_type", "save_comment");
      AddAndGetTicketComment(data)
        .then((response) => {
          $("#notifications").modal("hide");
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Posted comment successfully",
          });
        })
        .catch((error) => {
          console.error("AddAndGetTicketComment error :", error);
        });
    }
  })

  const handleSendResponse = (status, appealId) => {
    if (status === "Decline" && !studentMessage) {
      setMessageError("Message is Required")
      return;
    }
    setMessageError("")
    setAppealDisable(status)
    const tempDateObj = new Date(startDate);
    const dayOfMonth = tempDateObj.getDate();
    const month = tempDateObj.getMonth() + 1; // add 1 to month since it is 0-based
    const year = tempDateObj.getFullYear();
    const hours = tempDateObj.getHours();
    const minutes = tempDateObj.getMinutes();
    const tempDate = `${year}-${month < 10 ? "0" + month : month}-${dayOfMonth < 10 ? "0" + dayOfMonth : dayOfMonth}T${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes}:00.000Z`;
    const data = new FormData();
    data.append("student_id", studentId);
    data.append("student_message", studentMessage ? studentMessage : "");
    data.append("assessment_id", subId);
    data.append("assessment_close_date", tempDate);
    data.append("status", status);
    data.append("gradebookType", 1);
    data.append("appealOutcome", appealsDetails?.student_appeal?.appeal_outcome);
    ApproveOrDeclineAppeal(data)
      .then((res) => {
        handleGetAppealDetails(appealId)
        Swal.fire({
          icon: "success",
          title: "Success",
          text: res.data.message,
        })
        setAppealDisable("")
        getSubmissionData()
        setStudentMessage("")
        $("#notifications1").modal('hide');
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.response.data.message,
        })
        $("#notifications1").modal('hide');
        console.error("error : ", err)
        setStudentMessage("")
        setAppealDisable("")
      });
  };

  const handleHybridResultChange = (e, id, type, maxMark) =>{
    let marks = "";
    setHGear(id)
    if (type === "inputbox") {
      if (e.target.value > maxMark) {
        setErrorMessage("Sorry you can't put mark more then assignment mark")
        return false      
      } else {
        marks = e.target.value
      }
    }else if (type === "selectbox") {
      marks = e?.value
    }

    let sendData = new FormData();
    sendData.append("submission_id", id);
    if(type === "inputbox"){
      sendData.append("hybrid_marks", marks);
    }else{
      if (marks === "0") {
        sendData.append("hybrid_marks", 0);        
      }else if (marks === "49") {
        sendData.append("hybrid_marks", 49);        
      }else if (marks === "100") {
        sendData.append("hybrid_marks", 100);        
      }else {
        sendData.append("hybrid_marks", "");        
      }
    }
    setLoading(true);
    UpdateHybridMarks(sendData).then((res)=>{
      if(res.status==200){
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Updated successfully",
        });
        setErrorMessage("")
        setupDatedata(!updatedata)
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    }).catch((err)=>{
      console.error("err : ", err?.response?.data);
      setLoading(true);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: `${err?.response?.data?.data}`,
      });
    })
  }

  // for showing loading effect update below state
  let updateArray = [...updateValueArr];

  
  // mycode start
  const handlegradeChange = (e, idvalue, type, maxMark, item) => {   
    let entervalue = ""
    setGearid(item?.attempt_id)
    if (type === "inputbox") {
      if (e.target.value > maxMark) {
        setErrorMessage("Sorry you can't put mark more then assignment mark")
        return false        
      } else {
        entervalue = e.target.value
      }
    } else if (type === "selectbox") {
      entervalue = e?.value
    }


    let formData = new FormData();

    if (type === "inputbox") {
      formData.set("obtMark", entervalue)
      formData.set("id", idvalue)
      formData.set("ass_total_mark", maxMark)
      formData.set("custome_marking_deadline_date", headerData.marking_deadline_date)
      formData.set("assgrade", item.grade)
      formData.set("assessmentID", subId)
    } else {
      if(item.grade==1){
        if (entervalue === "0") {
          formData.set("obtMark", 0);
          formData.set("id", idvalue)
          formData.set("ass_total_mark", maxMark)
          formData.set("grade", "robot")
        } else if (entervalue === "49") {
          formData.set("obtMark", 49);
          formData.set("id", idvalue)
          formData.set("ass_total_mark", maxMark)
          formData.set("grade", "robot")
        } else if (entervalue === "100") {
          formData.set("obtMark", 100);
          formData.set("id", idvalue)
          formData.set("ass_total_mark", maxMark)
          formData.set("grade", "robot")
        } else {
          formData.set("obtMark", "");
          formData.set("id", idvalue)
          formData.set("ass_total_mark", maxMark)
          formData.set("grade", "robot")
  
        }
      }else if(item.grade == 2){
        formData.set("id", idvalue)
        formData.set("ass_total_mark", maxMark)
        formData.set("grade", "letter")
        formData.set("grade_id", entervalue);
      }
    }
    setLoading(true);
    UpDateMarkssubmit(formData)
      .then((res) => {
        // Swal.fire({
        //   icon: "success",
        //   title: "Success",
        //   text: "Updated successfully",4
        // });
        setErrorMessage("")
        setupDatedata(!updatedata)        
      })
      .catch((err) => {
        console.error("ey : ", err?.response?.data);
        setLoading(true);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `${err?.response?.data?.data}`,
        });
      }).finally(()=>{setLoading(false);});
  }
  
  const handleUpdateMarks = (obtMark, idvalue, type, maxMark, item, intake) => {

    let updateArray = [...updateValueArr]

    const existingIndex = updateArray.findIndex((grade) => grade.student_id == idvalue && grade?.intake === intake);

    let data = allUserData?.find((user) => user.id == item?.id && user?.getGradeSettings?.intake === intake)

    let returnIndex = userData.findIndex(obj => obj.quiz_student_id === idvalue && obj.getGradeSettings?.intake === intake);

    if ((item?.getGradeSettings?.grading_type == 0 || item?.getGradeSettings?.grading_type == 3) && obtMark > maxMark) {
      setGearid(item?.attempt_id)
      setErrorMessage("Sorry you can't put mark more then assignment mark");

      userData[returnIndex].ass_mark = data?.ass_mark;
      if (existingIndex !== -1) {
        updateArray = updateArray.filter(i => i.student_id !== idvalue && i?.intake === intake);
        setUpdateValueArr([...updateArray]);
      }
      return;
    } else {
      setErrorMessage("");
      setGearid("")
    }

    const isEmpty = !obtMark || obtMark == "";
    const isDifferent = obtMark != data?.ass_mark;
    const isSpecialZeroCase = obtMark == "0" && data?.ass_mark == "0" && data?.mark == null;
    let matchesOriginal;
    if (isEmpty) {
      matchesOriginal = data?.mark == null;
    } else if (obtMark == "0") {
      matchesOriginal = data?.mark != null && data?.ass_mark == "0";
    } else {
      matchesOriginal = obtMark == data?.ass_mark;
    }


    const needsTracking = isEmpty ? data?.mark != null : (isDifferent || isSpecialZeroCase) && !matchesOriginal;

    // Update tracking array
    if (needsTracking) {
      const gradeData = {
        student_id: idvalue,
        grade_type: (item?.getGradeSettings?.grading_type == 0 || item?.getGradeSettings?.grading_type == 3) ? 3 : item?.getGradeSettings?.grading_type,
        grade: obtMark ?? "",
        intake: intake,
        attempt_id: item?.attempt_id,
      };

      if (existingIndex !== -1) {
        updateArray[existingIndex] = gradeData;
      } else {
        updateArray.push(gradeData);
      }
    } else if (existingIndex !== -1) {
      updateArray = updateArray.filter(i => i.student_id !== idvalue && i?.intake === intake);
    }

    if (returnIndex !== -1) {
      if (item?.getGradeSettings?.grading_type == 0 || item?.getGradeSettings?.grading_type == 3) {
        userData[returnIndex].ass_mark = obtMark;
      } else {
        if (item?.getGradeSettings?.grading_type && item?.getGradeSettings?.grading_type == 2) {
          const selectedVal = item?.assCalculateGradeStatus?.letterGrades?.find(item => item.value == obtMark);
          userData[returnIndex].ass_percentage = selectedVal?.max_score + "%";
        } else {
          userData[returnIndex].ass_percentage = obtMark + "%";
        }
      }
    }
    setUpdateValueArr([...updateArray]);
  };

  const shouldBlockNavigation = updateValueArr.length;

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (shouldBlockNavigation) {
        event.preventDefault();
        // event.returnValue = ''; // This is necessary for Chrome/Firefox
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [shouldBlockNavigation]);

  const handleNavigation = (location, page, states) => {
    setToggle(!toggle)
    // getSubmissionData()
    if (!isSaveGradesDisabled?.includes(1) && shouldBlockNavigation) {
      if (Swal.isVisible()) {
        return false;
      }
      Swal.fire({
        title: "Warning",
        text: "You Have Unsaved Changes Left! Do you want to save changes",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No, Leave",
        confirmButtonText: "Yes, Save Changes",
      }).then((value) => {
        if (value.isConfirmed) {
          Swal.fire({
            title: "Please wait",
            text: "Saving changes...",
            allowOutsideClick: false,
            onBeforeOpen: () => {
              Swal.showLoading();
              const values = {
                type: 0,
                assessmnet_id: subId,
                grademix: updateValueArr,
              };
              updateSubmissionMarks(values)
                .then((res) => {
                  getSubmissionData()
                  setUpdateValueArr([]);
                  Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Updated Successfully",
                  }).then(() => {
                    if (location) {
                      history.push(location.pathname)
                    }
                  });
                })
                .catch((err) => {
                  Swal.close(); // Close the "Saving changes..." popup if there was an error
                  Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: `${err?.response?.data?.data}`,
                  });
                });
            },
          });
        } else {
          getSubmissionData()
          setUpdateValueArr([]);
          if (location) {
            history.push(location.pathname)
          }
        }
      });

      return false; // Prevent the default navigation behavior
    }
  };

  const handleSaveGrades = (studentID) => {
    Swal.fire({
      title: "Updating",
      onOpen: function () {
        Swal.showLoading();
      },
    });
    setSaveGradesLoading(true);
    const values = {
      type: 0,
      assessmnet_id: subId,
      grademix: updateValueArr,
    };
    if (!studentID) {
      delete values.student_id;
    }
    updateSubmissionMarks(values)
      .then((res) => {     
        if (res.status == 200) {
          getSubmissionData()
          if (studentID) {
            const filteredArr = updateValueArr.filter(
              (item) => item.student_id !== studentID
            );
            setUpdateValueArr(filteredArr);
          } else {
            setUpdateValueArr([]);
          }
          Swal.close();
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Updated Successfully",
          });
        }
      })
      .catch((err) => {
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `${err?.response?.data?.data}`,
        });
      }).finally(() =>{
        setSaveGradesLoading(false);
      });
  };

  const setNotificationvalue = (e) => {
    const check = e.target.checked
    check === true ? setNotificationVal(true) : setNotificationVal(false)
  }

  const submitNotification = (e, type) => {
    const data = new FormData();
    data.append("assignmentid", subId);
    data.append("intake", id);
    data.append("act", type == "reOpen" ? 0 : 1);
    data.append("notifyToAll", notificationval)
    GetMarkasCompelete(data)
      .then((response) => {
        popupSuccessSimple("successfully");
        setNotificationVal(false)
        setUpdateValueArr([])
        getSubmissionData();
        $("#exampleModal2").modal("hide");
      }).catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: 'Error',
        });
      });
  }

  function calculateFileSize(data, maxSizePerArray) {
    let totalSize = 0;
    let urlArray = [];
    let checkTotal = 0;
    let urlArrays = [[]]; // Start with one empty array
    let currentArrayIndex = 0;
    let currentArraySize = 0;

    function addToCurrentArray(path, size, fileName, currentSize,inExamWarning) {
      const urlInfo = {
        path: path,
        size: size,
        loaded_Size: 0,
        flname: fileName,
        inExamWarning : inExamWarning,
      };
      urlArrays[currentArrayIndex].push(urlInfo);
      urlArray.push(urlInfo);
      currentArraySize += currentSize;
    }

    for (const item of data) {
      if (currentArraySize > maxSizePerArray) {
        currentArrayIndex++;
        urlArrays.push([]);
        currentArraySize = 0;
      }

      if (item.multipleFiles && item.multipleFiles.length) {
        for (const file of item.multipleFiles) {
          checkTotal++;
          const size = parseFloat(file.size);
          if (!isNaN(size)) {
            totalSize += size;
            if (currentArraySize + size <= maxSizePerArray) {
              addToCurrentArray(file.path, file.size, item.flname, size);
            } else {
              currentArrayIndex++;
              urlArrays.push([]);
              currentArraySize = 0;
              addToCurrentArray(file.path, file.size, item.flname, size);
            }
            urlArray.push({ path: file.path, size: file.size, loaded_Size: 0, flname: item.flname });
          }else{
            addToCurrentArray(file.path, file.size, item.flname, size,file.inExamWarning);
          }
        }
      } else {
        if (item.path && item.path.trim() !== "") {
          checkTotal++;
          const size = parseFloat(item.size);
          if (!isNaN(size)) {
            totalSize += size;
            if (currentArraySize + size <= maxSizePerArray) {
              addToCurrentArray(item.path, item.size, item.flname, size);
            } else {
              currentArrayIndex++;
              urlArrays.push([]);
              currentArraySize = 0;
              addToCurrentArray(item.path, item.size, item.flname, size);
            }
            urlArray.push({ path: item.path, size: item.size, loaded_Size: 0, flname: item.flname });
          }
        }
        if (item.return && item.return.trim() !== "") {
          checkTotal++;
          const size = parseFloat(item.return_size);
          if (!isNaN(size)) {
            totalSize += size;
            if (currentArraySize + size <= maxSizePerArray) {
              addToCurrentArray(item.return, item.return_size, item.flname, size);
            } else {
              currentArrayIndex++;
              urlArrays.push([]);
              currentArraySize = 0;
              addToCurrentArray(item.return, item.return_size, item.flname, size);
            }
            urlArray.push({ path: item.return, size: item.return_size, loaded_Size: 0, flname: item.flname });
          }
        }
      }

      if(item.quizSubmitedDocs && item.quizSubmitedDocs.length){
        for(const file of item.quizSubmitedDocs){
          checkTotal++;
          const size = 0;
          if (!isNaN(size)) {
              urlArrays[currentArrayIndex].push({
                path: file.docs,
                size: 0,
                loaded_Size: 0,
                flname: item.flname,
              });
            urlArray.push({ path: file.docs, size: 0, loaded_Size: 0, flname: item.flname });
          }
        }
      }
    }

    return {
      totalSize, urlArray, checkTotal, urlArrays
    };
  }

  const MAX_CONCURRENT_DOWNLOADS = 5; // Limit the number of parallel downloads

  const handleStudentDownload = async (rowData, st_data) => {
    let pending = 0;
    var zip = new JSZip();
    var zipVal = {};
    let checkTotal = 0;
    let totalSize = 0;
    let data = rowData;

    // Check if there is any file without submited_type in the data
    let isFolderNeeded = false;
    for ( let d of rowData){
      if(d?.inExamWarning){ 
        isFolderNeeded = true;
      }
    }
    let warningsFolder = ''
    // Create the warnings folder in the zip
    if(isFolderNeeded){
      warningsFolder = zip.folder("Exam Warnings");
    }
    
    if (Array.isArray(data) && data.length) {
      let sizeArr = Array(data.length).fill(0);
      let myPromise = Promise.all(
        data.map(async (row, index) => {
          if (row.path && row.path != null && row.path != "") {
            checkTotal++
            setCheckTotal(checkTotal)
            const size = parseFloat(row?.size);
            if (!isNaN(size)) {
              totalSize += size;
              setFinalTotal(totalSize.toFixed(1));
            }
           if (!row.path) {
             console.warn("Skipping empty path for", row);
             return;
           }
           const fileExt = safeFileName(row.path);            
           if (!row.path) return;   
           const fileURL = row.path?.startsWith('https://') ? encodeURI(row.path) :  downloadURL+`${row.path.includes("s3.af-south-1.amazonaws.com") ? "" : STUDENT_FILE_DOWNLOAD.replace("https://","")+"/"}${encodeURI(row.path.replace(
              "/home/myaie/public_html/","").replace("public/",""))}`;
            let loadedFromArr = 0
            try {
              const resp = await axios({
                url: fileURL,
                method: 'get',
                responseType: 'blob',
                onDownloadProgress: (progressEvent) => {
                  const { loaded, total } = progressEvent;
                  sizeArr[index] = loaded
                  loadedFromArr = 0
                  sizeArr.map(item => loadedFromArr = loadedFromArr + item)
                  if(totalSize > loadedFromArr) {
                    setFinalLoadedData(loadedFromArr)
                  }else{
                    setFinalLoadedData(totalSize)
                  }
                }
              })
              
              // Store file in warnings folder if type is undefined, otherwise in root
              if (row?.inExamWarning) {
                warningsFolder.file(`${fileExt}`, resp.data, { binary: true });
              } else {
                zip.file(`${fileExt}`, resp.data, { binary: true });
              }
              
              pending++
              setCheckPending(pending)
            } catch(err) {
              pending++
              setCheckPending(pending)
            }
          }
          zipVal = zip
        })
      );
        
      myPromise.then(() => {
        zipVal.generateAsync({ type: "blob" })
          .then(function (content) {
            setTimeout(() => {
              $("#downloadAssessment").modal("hide");
              setCheckPending(0);
              setCheckTotal(0);
              setLoaded(0);
              setTotal(0);
              setFinalLoadedData(0)
              setFinalTotal(0)
            }, 1000);                 
            saveAs(content, `${assName}_${st_data?.name}_${st_data?.student_crm_id}` + ".zip");
          }).catch((errr) => { console.log(errr) });
      })
    } else {
      if (data && data != null && data != "") {
        setCheckTotal(1)
        setcheckAssignment("true")
        const fileExt = data?.path?.split("/")?.reverse()[0];
        const fileURL = data.path?.startsWith('https://') ? encodeURI(data.path) : downloadURL+`${data.path.includes("s3.af-south-1.amazonaws.com") ? "" : STUDENT_FILE_DOWNLOAD+"/"}${encodeURI(data.path.replaceAll(
          "/home/myaie/public_html/","").replace("public/",""))}`;
        try {
          const resp = await axios({
            url: fileURL,
            method: 'get',
            responseType: 'blob',
            onDownloadProgress: (progressEvent) => {
              const { loaded, total } = progressEvent;
              const size = parseFloat(data?.size);
              if (!isNaN(size)) {
                totalSize = size;
              }
              setFinalTotal(totalSize.toFixed(1))
              if(totalSize > loaded) {
                setFinalLoadedData(loaded)
              }else{
                setFinalLoadedData(totalSize)
              }
            }
          })
          
          // For single file case, create a zip with warnings folder if type is undefined
          if (data?.inExamWarning) {
            const warningsZip = new JSZip();
            const warningsFolder = warningsZip.folder("Exam Warnings");
            warningsFolder.file(fileExt, resp.data, { binary: true });
            
            warningsZip.generateAsync({ type: "blob" })
              .then(function (content) {
                saveAs(content, `${assName}_${st_data?.name}_${st_data?.student_crm_id}` + ".zip");
              });
          } else {
            // Original direct download for non-warning files
            const href = URL.createObjectURL(resp.data);
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', fileExt);
            document.body.appendChild(link);
            link.click();
          }
          
          pending++
          setCheckPending(pending)
          setTimeout(() => {
            $("#downloadAssessment").modal("hide");
            setCheckPending(0);
            setCheckTotal(0);
            setLoaded(0);
            setTotal(0);
            setPercent(0)
            setFinalLoadedData(0)
            setFinalTotal(0)
          }, 1000);
        } catch(err) {
          console.log(err)
        }
      }
    }
}

  const handlefileinput = () => {
    inputRef.current.click()
  }

  const handleFileChange = (event) => {
    setZipFileUpload(event.target.files[0])
  }
  const submitZipForm = () => {
    const data = new FormData();
    data.append("import", zipfileupload[0].file)
    data.append("intake", id)
    setImportLoading(true)
    GetimportMarks(data)
      .then((response) => {
        popupSuccessSimple("successfully");
        setZipFileUpload("")
        setImportLoading(false)
        $("#inputfileupload").val("");
        $("#exampleModalCenter").modal("hide");
      }).catch((error) => {
        console.error("zipupload error", error)
        Swal.fire({
          icon: "error",
          title: "Error",
          text: 'Error',
        });
        setImportLoading(false)
      })
  }
  // mycode end

  const userID = useSelector(state => state.user.UserID);

  const sendInstruction = () => {
    setInstructionLoading(true)
    const sendData = {
      assessment_marker: headerData.assessment_marker,
      sender: userID,
      assignmentid: headerData.assessment_id,
      close_date_time: headerData.close_date_time,
      marking_deadline_date: headerData.marking_deadline_date,
      intake: headerData.intake
    }
    SendAssignmentInstruction(sendData).then((res) => {
      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Instructions sent successfully",
        });
        setInstructionLoading(false)
      }
    }).catch((err) => { setInstructionLoading(false); console.error(err) })
  }

 const handleDownloadResults = async () => {
     try {
       setDownloading(true);
       const parameter = { assignment: subId };
       const res = await DownloadAssessmentsStudentResults(parameter);
   
       if (res.status === 200) {
         let respData = res.data.data;
         let data1 = downloadZip;
         let demoData = downloadZip;
         const header = [
           "Student Number",
           "Student Name", 
           "Final Mark",
           "Question Name",
           "Question",
           "Student Answer",
           "Correct Answer",
           "Mark",
           "Result",
         ];
         
         const formatData = [];

         respData.map((data)=>{
           let dataItem = {
           "Student Number" : data.student_crm_id,
           "Student Name" : `${data.first_name} ${data.last_name}`,
           "Final Mark" : `${data.ass_mark}/${data.ass_total_mark}`,          
           "Question Name" : "",
           "Question" : "",
           "Student Answer" : "",
           "Correct Answer" : "",
           "Mark" : "",
           "Result" : "",
           }
           formatData.push(dataItem)
           data.result && data.result.dataAns && data.result.dataAns.map((quesData, index)=>{
             if(quesData.questionType != "Document Upload" && quesData.questionType != "Long Answer") {
               let subDataItem = {
                 "Student Number" : "",
                 "Student Name" : "",
                 "Final Mark" : "",          
                 "Question Name" : quesData.question_name.length < 32000 ? quesData.question_name : "Data length is too large",
                 "Question" : quesData.question ? (convertToPlain(quesData.question).length < 32000 ? convertToPlain(quesData.question) : "Data length is too large") : "NA",
                 "Student Answer" : convertToPlain(quesData.UserAnswer).length < 32000 ? convertToPlain(quesData.UserAnswer) : "Data length is too large",
                 "Correct Answer" : convertToPlain(quesData.correctAnswer).length < 32000 ? convertToPlain(quesData.correctAnswer) : "Data length is too large",
                 "Mark" : `${twoDecimalRound(data.result.scoreArray[index])}/${twoDecimalRound(data.result.total_score_individual[index])}`,
                 "Result" : (data.result?.total_score_individual ? data.result?.total_score_individual[index] == 0 : data.result?.scoreArray[index] == 0)  ? RenderQuizResult("0").text 
                           : data.result?.scoreArray[index] == 0 ? RenderQuizResult("0").text : (quesData.questionType == "Multiple Choice Multiple Answer" || quesData.questionType == "Match the Column") 
                           && (data.result?.total_score_individual ? data.result.scoreArray[index]/data.result?.total_score_individual[index] != 0 : data.result.scoreArray[index]/data.result.scoreArray[index] != 0 ) 
                           ? RenderQuizResult((data.result.scoreArray[index]/data.result?.total_score_individual[index]).toString()).text : parseInt(data.result.scoreArray[index]) == (data.result?.total_score_individual[index] 
                             ? data.result?.total_score_individual[index] : data.result.scoreArray[index]) ? RenderQuizResult("1").text : RenderQuizResult("0").text,
               }
               formatData.push(subDataItem);
             }
           })          
         });
         const compatibleData = formatData.map((row) => {
           const obj = {};
           header.map((col, index) => {
             obj[col] = row[col];
           });
           return obj;
         });

         // Format data similar to handleDownloadAssessment
         data1 = data1?.map((row) => ({
           ...row,
           SID: row.student_crm_id ? row.student_crm_id : "",
           STUDENT: row.first_name ? `${row.first_name} ${row.last_name}` : "",
           SURNAME: row.last_name ? row.last_name : "",
           "ASSESSMENT NAME": zipfilename ? zipfilename.trim() : "",
           "HIGHEST MARK ACHIEVABLE": row.ass_total_mark >= 0 ? row.ass_total_mark : "",
           "MARKED ACHIEVED": row.ass_mark != null && row.ass_mark.toString() ? row.ass_mark : "",
           dataAns: row.result?.dataAns || []
         }));
   
         const maxSizePerArray = 1536 * 1024 * 1024;
         let fileDetails = calculateFileSize(demoData, maxSizePerArray);
         setFinalTotal(fileDetails.totalSize.toFixed(1));
         let loadedArr = JSON.parse(JSON.stringify(fileDetails.urlArrays));
   
         let zipPromises = [];
         for (
           let i = 0;
           i < fileDetails.urlArrays.length;
           i += MAX_CONCURRENT_DOWNLOADS
         ) {
           const batch = fileDetails.urlArrays.slice(
             i,
             i + MAX_CONCURRENT_DOWNLOADS
           );
           const batchPromises = batch.map(async (urlArray, index) => {
             let zip = new JSZip();
             let sizeArr = Array(urlArray.length).fill(0);
             let loadedBytes = 0;
   
             let promise = Promise.all(
               urlArray.map(async (row, rowIndex) => {
                 const fileExt = row.path
                   .split("/")
                   .reverse()[0]
                   .trim()
                   .replace(/[\t\r\n]/g, "");
                 let fileURL =
                   downloadURL +
                   `${
                     row.path.includes("s3.af-south-1.amazonaws.com")
                       ? ""
                       : STUDENT_FILE_DOWNLOAD.replace("https://","") + "/"
                   }${row.path
                     .replaceAll("/home/myaie/public_html/", "")
                     .replace("public/", "")}`;
                 if (isHybrid === true) {
                   fileURL =
                     downloadURL +
                     STUDENT_FILE_DOWNLOAD.replace("https://","") +
                     `/${row.path
                       .replaceAll("/home/myaie/public_html/", "")
                       .replace("public/", "")}`;
                 }
                 let loadedFromArr = 0;
                 try {
                   const resp = await axios({
                     url: fileURL,
                     method: "get",
                     responseType: "blob",
                     onDownloadProgress: (progressEvent) => {
                       const { loaded, total } = progressEvent;
                       loadedArr[index][rowIndex] = loaded;
                       loadedFromArr = 0;
                       loadedArr.map((item) =>
                         item.map((subItem) => {
                           if (typeof subItem === "number") {
                             loadedFromArr = loadedFromArr + subItem;
                           }
                         })
                       );
                       loadedBytes = loaded;
                       if (fileDetails.totalSize > loadedFromArr) {
                         setFinalLoadedData(loadedFromArr);
                       } else {
                         setFinalLoadedData(fileDetails.totalSize);
                       }
                     },
                   });
   
                   // Create student folder with exam warnings subfolder
                   let zipFolder = zip.folder(`${row.flname + "_" + zipfilename.trim().replace(/[\t\r\n]/g, '')}`);
                   let newUrlArr = urlArray.filter(item => row.flname == item.flname)
   
                   let isFolderNeeded = false;
                   for (let d of newUrlArr){
                     if(d?.inExamWarning){ 
                       isFolderNeeded = true;
                     }
                   }
                   let warningsFolder = '';
                   // Create the warnings folder in the zip
                   if(isFolderNeeded){
                     warningsFolder = zipFolder.folder("Exam Warnings");
                   }
   
                   if (row?.inExamWarning) {
                     warningsFolder.file(`${fileExt}`, resp.data, { binary: true });
                   }             
                 } catch (err) {
                   console.log(err, "zip generation error");
                 }
               })
             );
   
             promise = promise.then(() => {
               // Add text files for question answers
               const textFileData = data1.filter((item) => item.dataAns);
               if (textFileData.length) {
                 textFileData.map((row) => {
                   let fileContent = "";
                   if (Array.isArray(row.dataAns) && row.dataAns.length) {
                     row.dataAns.map((element) => {
                       fileContent +=
                         "Question : " +
                         element.questionName +
                         "Answer : " +
                         element.UserAnswer +
                         "\n" +
                         "\n";
                     });
                   }
                   if (fileContent != "") {
                     zip
                       .folder(
                         `${
                           row.flname +
                           "_" +
                           zipfilename.trim().replace(/[\t\r\n]/g, "")
                         }`
                       )
                       .file("question.txt", fileContent);
                   }
                 });
               }
   
               // Generate XLSX file
               let wb = XLSX.utils.book_new();
               let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
                 header,
               });
               XLSX.utils.book_append_sheet(wb, ws1, "Results Data");
               const xlsxBuffer = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
               
               zip.file(`${zipfilename + "_" + index + ".xlsx"}`, xlsxBuffer);
   
               return zip.generateAsync({ type: "blob" });
             });
   
             try {
               const zipBlob = await promise;
               const zipFileName = `${zipfilename}_${
                 i / MAX_CONCURRENT_DOWNLOADS + index + 1
               }_.zip`;
               saveAs(zipBlob, zipFileName);
             } catch (err) {
               console.error("Error generating or downloading zip files:", err);
             }
           });
           zipPromises.push(Promise.all(batchPromises));
         }
   
         await Promise.all(zipPromises);
       }
     } catch (error) {
       console.error("Error generating or downloading zip files:", error);
     } finally {
       setTimeout(() => {
         $("#downloadAssessment").modal("hide");
         setFinalLoadedData(0);
         setFinalTotal(0);
         setDownloading(false);
       }, 1000);
     }
   };

  const handleChangeAppealOutcome = (outcome) =>{
    const appealData = {...appealsDetails};
    appealData.student_appeal.appeal_outcome = outcome;
    setAppealsDetails({...appealData})
  }

  const paginationComponentOptions = {
    selectAllRowsItem: true,
    selectAllRowsItemText: 'View All',
  };

  return (
    <>
       <Prompt when={!!shouldBlockNavigation} message={handleNavigation} />
      <div className="card-new card card-profile-info-card mb-30">
        <div className="">
          <div className="card-header">Marking Management {loading && <i className="fas fa-cog fa-spin ml-2"></i>}</div>
          <div className="card-body-inr card-body-info">
            <div className="basic-info-box">
              <div className="row">
                {(headerData && headerData.quiz_id && isHybrid==false) ? "" : <div className="col-md-6 col-lg-4">
                  <div className="basic-info-box-list">
                    <ul>
                      <li>
                        <span className="title">Mark Status :</span>
                        <span>
                          {headerData ? headerData.mark_status == "Past Due" ?
                            <span style={{ color: "#FF0000" }}> &nbsp;Past Due</span>
                            : headerData.mark_status : "-"}
                          <span>
                            &nbsp;
                            <button onClick={() => { sendInstruction() }} type="button" className="btn-save btn btn-primary">
                              {instructionLoading ? <i className="fas fa-cog fa-spin"></i> : ""} Send Instruction
                            </button>
                          </span>
                        </span>
                      </li>
                      <li>
                        <span className="title ">Marking deadline :</span>
                        <span>{headerData && headerData.MarkingDeadLine ? headerData.MarkingDeadLine : "-"}</span>
                      </li>
                    </ul>
                  </div>
                </div>}
                <div className="col-md-6 col-lg-4">
                  <div className="basic-info-box-list">
                    <ul>
                      <li style={{ color: "#FF0000" }}>
                        <span className="title">Submissions :</span>
                        <span>&nbsp;{headerData && headerData.submissions ? headerData.submissions : "-"}</span>
                      </li>
                      <li style={{ color: "#FF0000" }}>
                        <span className="title">Submission rate :</span>
                        <span>&nbsp;{headerData && headerData.submissions_rate ? headerData.submissions_rate : "-"}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6 col-lg-4">
                  <div className="basic-info-box-list">
                    <ul>
                      <li>
                        <span className="title">Appeals:</span>
                        <span>{headerData && headerData.TOTAL_APPEALES && headerData.TOTAL_APPEALES.toString() ? headerData.TOTAL_APPEALES : "-"}</span>
                      </li>
                      <li>
                        <span className="title">Average Mark:</span>
                        <span>{headerData && headerData.AvgMarks && headerData.AvgMarks.toString() ? headerData.AvgMarks : "-"}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* {/ button section start /} */}
          <div className="button-reset dropdown-comman assessment-buttons-container">
            {headerData && headerData.quiz_id ?
              <>
                <button className="btn btn-primary" title="Marking View" onClick={() => history.push(`/courseAdministration/coursesdetails/${id}/assessments/open/assigned/assessmentMarking/${subId}`)}>
                  <i className="fal fa-clipboard-check"></i>Marking View
                </button>
               
              </> : null
            }
            {!(headerData && headerData.quiz_id && isHybrid===false) ?
            <>
            <DownloadModalComponent children={
              <button type="button" className="btn btn-save btn-success" title="Download Assessments" data-toggle="modal" data-target="#downloadAssessment">
                <i className="fal fa-arrow-down"></i>Download Assessments
              </button>
            } modalId={'downloadAssessment'} downloadRef={downloadRef} zipName={assName} type={'downloadAssessment'} assId={subId} payload={{assignmentId : subId , intake : id}}/>
            
            </>: null}
            {(headerData && headerData.quiz_id && !isHybrid) ? "" : <>
            <button className="btn btn-primary" title="Import Marks" data-toggle="modal" disabled={headerData?.notify_assessed} data-target="#exampleModalCenter">
              <i className="fal fa-arrow-up"></i>Import Marks
            </button>
           
            </>}             
            <>
            {headerData?.notify_assessed ? <button title="Re-Open Marking" className="btn btn-primary" onClick={(e) => submitNotification(e, "reOpen")}>
                <i className="fal fa-bell"></i>Re-Open Marking
              </button> : <button className="btn btn-primary" title="Mark as Complete" data-toggle="modal" data-target="#exampleModal2" disabled={false /*isSubmissionMarked}>*/}> 
                <i className="fal fa-bell"></i>Mark as Complete
              </button>}
             
            </>
            {(headerData && headerData.quiz_id) ?
              <DownloadModalComponent children={
                <button type="button" className="btn btn-primary" title="Download Smart Assessment Results" data-toggle="modal" data-target="#downloadSmartAssessment">
                  <i className="fal fa-arrow-down"></i>Download Smart Assessment Results
                </button>
              } modalId={'downloadSmartAssessment'} downloadRef={downloadRef2} zipName={assName} type={'downloadSmartAssessment'} assId={subId} payload={{ assignmentId: subId, isSmartAssessment: 1, intake : id }} />
              : null}
          </div>
          {/* {/ button end /} */}
        </div>
      </div >

      {/* {/ popup1 section start /} */}
      <div className="modal fade" id="exampleModalCenter" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">Import csv for mark capture</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="import_capture_inputs">
                <form onSubmit={submitZipForm}>
                  <div className="drag_card_btn">
                                            <FilePond
                                                name="CSVFILE"
                                                allowMultiple={false}
                                                ref={inputRef}
                                                files={zipfileupload}
                                                onupdatefiles={setZipFileUpload}
                                                acceptedFileTypes='application/csv,text/csv,.csv'
                                            />
                                        </div>
                </form>
              </div>
            </div>
            <div className="modal-footer">
              <button type="submit" disabled={!zipfileupload} className="btn btn-primary" onClick={submitZipForm}>Import</button>
              <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={()=>setZipFileUpload("")}>Cancel</button>
            </div>
          </div>
        </div>
      </div>
      {/*popup1 section end */}


      {/* / popup2 section start / */}
      <div className="modal fade" id="exampleModal2" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Notification !</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" disabled={notificationval}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <input type="checkbox" id="checkboxid" name="notificationval" checked={notificationval} onChange={(e) => setNotificationvalue(e)} />
              &nbsp;&nbsp;
              <label htmlFor="checkboxid">Notify All Students</label>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary" onClick={submitNotification}><i className="fal fa-check"></i>Send</button>
              <button type="button" className="btn btn-danger" data-dismiss="modal"><i className="fal fa-times"></i>Close</button>
            </div>
          </div>
        </div>
      </div>
      {isLoading ? <SkeletonTicketList /> : <DataTableComponentFrontPagination
        data={dataToRender()}
        onSort={handleSort}
        columns={(headerData && headerData.quiz_id) ? (isHybrid===true ? hybridColumns : quizColumns) : columns}
        loading={isLoading}
        changePage={handleNavigation}
        search={search}
        setSearch={setSearch}
        conditionalRowStyles={conditionalRowStyles}
        exportData={exportData}
        exportFileName={"Submission-And-Result"}
        errorMessageMargin={(userData?.length && updateValueArr?.length) && errorMessage}
        defaultSort={{ defaultSortColumn: "name", defaultSortAsc: true }}
        filters={[
          {
            filterName: "Status",
            optionArr : filterData.studentsStatusFilters,
            state: status,
            setState: setStatus,
            renderLabelFunction: RenderSubmissionAndResultStatus,
          },
          {
            filterName: "Submission Status",
            optionArr: filterData.submissionStatusFilters,
            state: submissionStatus,
            setState: setSubmissionStatus,
            renderLabelFunction: RenderSubmissionStatus,
          },
          {
            filterName: "Linked Course",
            optionArr: filterData.intakeFilters,
            state: linkedCourse,
            setState: setLinkedCourse,
          },
        ]}
        bottomButton={[
          <div>
          {errorMessage ? (
            <div className="invalid-feedback d-block">{errorMessage}</div>
          ) : (
            ""
          )}
          </div>
        ]}
        otherTableProps={{paginationComponentOptions:paginationComponentOptions}}
      />}
      {userData?.length && updateValueArr?.length ? <GradeBookSaveBar handleClick={() => handleSaveGrades()} saveGradesLoading={saveGradesLoading} disabled={isSaveGradesDisabled?.includes(1)}
 /> : <></>}
      <PopupComponent
        id="notifications"
        type="form"
        header={{
          iconName: "fa-comment",
          heading: "Add Comment"
        }}
        inputs={[
          <div className="col-md-12">
            <div className="form-group-blk mb-3">
              <label>Comment *</label>
              <textarea
                name="comment"
                type="text"
                className={"form-control" + (formik.errors.comment && formik.touched.comment ? " is-invalid" : "")}
                value={formik.values.comment}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
          </div>
        ]}
        bottomButton={[
          <PermissionsGate scopes={["cedit"]} errorProps={{ disabled: true }}>
            <button type="button" className="btn btn-primary" onClick={formik.handleSubmit}>
              <i className="fal fa-save"></i>
              Post
            </button>
          </PermissionsGate>,
          <button type="button" className="btn btn-danger" data-dismiss="modal">
            <i className="fal fa-times"></i>
            Close
          </button>,
          formik.touched.comment && formik.errors.comment ? <div className="invalid-feedback d-block">{formik.errors.comment}</div> : null
        ]}
      />
      <PopupComponent
        closeFunction={()=> setStudentMessage("")}
        id="notifications1"
        type="multiple_details_blocks"
        header={{
          iconName: "fa-comment",
          heading: "Appeals"
        }}
        detailsBlocks={[
          {
            heading: "Assessment Detail",
            columns: [
              <>
                <div className="col-md-6">
                  <div className="basic-info-box-list modal-info-list">
                    <ul>
                      <li>
                        <span className="title">Assessment Name:</span>
                        <span>
                          {appealsDetails &&
                            appealsDetails.assignment.name}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="basic-info-box-list modal-info-list">
                    <ul>
                      <li>
                        <span className="title">Assessment Status:</span>
                        <span>
                          {appealsDetails &&
                            appealsDetails.student_appeal &&
                            appealsDetails.student_appeal?.ass_status}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="basic-info-box-list modal-info-list">
                    <ul>
                      <li>
                        <span className="title ">Opening Date:</span>
                        <span>
                          {appealsDetails &&
                            appealsDetails.assignment.open_date_time &&
                            moment
                              .unix(appealsDetails.assignment.open_date_time)
                              .format(TABLE_DATE_TIME_FORMAT)}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="basic-info-box-list modal-info-list">
                    <ul>
                      <li>
                        <span className="title">Code:</span>
                        <span>
                          {appealsDetails && appealsDetails.assignment.code}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="basic-info-box-list modal-info-list">
                    <ul>
                      <li>
                        <span className="title ">Due Date:</span>
                        <span>
                          {appealsDetails &&
                            appealsDetails.assignment.close_date_time &&
                            moment
                              .unix(appealsDetails.assignment.close_date_time)
                              .format(TABLE_DATE_TIME_FORMAT)}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="basic-info-box-list modal-info-list">
                    <ul>
                      <li>
                        <span className="title ">Your Result:</span>
                        <span>{appealsDetails && appealsDetails.student_appeal && appealsDetails.student_appeal.assessment_mark_per}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="basic-info-box-list modal-info-list">
                    <ul className="course-name-merge">
                      <li>
                        <span className="title ">
                          Appeal Submission Date:
                        </span>
                        <span>
                          {appealsDetails &&
                            appealsDetails.student_appeal &&
                            moment
                              .unix(
                                appealsDetails?.student_appeal?.submit_date
                              )
                              .format(TABLE_DATE_TIME_FORMAT)}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
               { appealsDetails && appealsDetails.student_appeal && appealsDetails.student_appeal.timeLimitActive == 1 ?<div className="col-md-6">
                  <div className="basic-info-box-list modal-info-list">
                    <ul className="course-name-merge">
                      <li>
                        <span className="title ">Assessment Launched:</span>
                        <span>
                          {appealsDetails &&
                            appealsDetails.assignment.close_date_time &&
                            moment
                              .unix(appealsDetails.assignment.close_date_time)
                              .format(TABLE_DATE_TIME_FORMAT)}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div> : ""}
                <div className="col-md-6">
                  <div className="basic-info-box-list modal-info-list">
                    <ul>
                      <li>
                        <span className="title ">Submission Status:</span>
                        <span>{appealsDetails && appealsDetails.student_appeal ? appealsDetails.student_appeal.appeal_status == "Declined" ? "Appeal-Declined" : appealsDetails.student_appeal.appeal_status : "NA"}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </>
            ]
          },
          {
            heading: "Registered Appeal",
            columns: [
              <div className="col-md-12">
                <div className="basic-info-box-list modal-info-list">
                  <ul>
                    <li>
                      <span className="title">
                        Reason for not submitting assessment:{" "}
                      </span>
                      <span>
                        {appealsDetails &&
                          appealsDetails.student_appeal &&
                          appealsDetails.student_appeal.ass_reason}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>,
              <div className="col-md-12">
                <div className="basic-info-box-list modal-info-list">
                  <ul>
                    <li>
                      <span className="title">Description: </span>
                      <span className="text-break">
                        {appealsDetails &&
                          appealsDetails.student_appeal &&
                          appealsDetails.student_appeal.description}
                      </span>
                    </li>
                  </ul>
                </div>
              </div>,
              <div className="col-md-12">
                <div className="basic-info-box-list modal-info-list">
                  <ul className="appeal-submission-list">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group-blk mb-3">
                          <li>
                            <span className="title ">
                              Supporting File :
                            </span>
                            <div className="d-block">
                              {appealsDetails &&
                                appealsDetails.student_appeal &&
                                appealsDetails.student_appeal.files &&
                                appealsDetails.student_appeal.files.length ?
                                appealsDetails.student_appeal.files.map(item => {
                                  return <a href={`${downloadURL}${item.file_url.replace(/(^\w+:|^)\/\//, '')}`} target="_blank" className="d-block" title={item.file}>{item.file.toString().split("/").reverse()[0]}&nbsp;</a>
                                }) : "-"}
                            </div>
                          </li>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group-blk mb-3">
                          <li>
                            <span className="title ">
                              Message Student :
                            </span>
                            <textarea
                              disabled={
                                (appealsDetails?.student_appeal?.appeal_status == "Approved" || appealsDetails?.student_appeal?.appeal_status == "Declined")
                                  ? true
                                  : false
                              }
                              type="text"
                              className="form-control"
                              value={studentMessage}
                              onChange={(e) =>
                                setStudentMessage(e.target.value)
                              }
                              cols={10}
                              id="message"
                              placeholder="Enter Message"
                              title="Enter Message"
                            />
                          </li>
                        </div>
                      </div>
                      {appealsDetails?.student_appeal?.appeal_status !=="Declined" ? <div className="col-md-12 mb-2">
                        <div className="form-group-blk">
                          <li>
                            <span className="title ">
                              Appeal Outcome :
                            </span>
                            <div className="form-icon-group" title="">
                              <div className="prefix-sufix-box">
                                <div
                                  style={{ zIndex: "inherit" }}
                                  className="custom-control custom-radio custom-control-inline"
                                  title="Grant Extension"
                                >
                                  <input
                                    type="radio"
                                    id="grantExtension"
                                    name="appealOutcome"
                                    disabled={!(appealsDetails?.student_appeal?.appeal_status != 'Approved' && appealsDetails?.student_appeal?.appeal_status != 'Declined')}
                                    checked={appealsDetails && appealsDetails?.student_appeal && appealsDetails?.student_appeal?.appeal_outcome == 0}
                                    onChange={() => {handleChangeAppealOutcome(0)}}
                                    className="custom-control-input"
                                    // onBlur={formik.handleBlur}
                                  />
                                  <label
                                    className="custom-control-label custom-control-inline"
                                    htmlFor="grantExtension"
                                  >
                                    Grant Extension
                                  </label>
                                </div>
                                <div
                                  style={{ zIndex: "inherit" }}
                                  className="custom-control custom-radio custom-control-inline"
                                  title="Move to Sick Test"
                                >
                                  <input
                                    type="radio"
                                    id="movetosick"
                                    disabled={(!(appealsDetails?.student_appeal?.appeal_status != 'Approved' && appealsDetails?.student_appeal?.appeal_status != 'Declined'))}
                                    name="appealOutcome"
                                    checked={appealsDetails && appealsDetails?.student_appeal && appealsDetails?.student_appeal?.appeal_outcome == 1}
                                    onChange={() => {handleChangeAppealOutcome(1)}}
                                    className="custom-control-input"
                                  />
                                  <label
                                    className="custom-control-label custom-control-inline"
                                    htmlFor="movetosick"
                                  >
                                    Move to Sick Test
                                  </label>
                                </div>
                              </div>
                            </div>
                          </li>
                        </div>
                      </div> : ""}
                      {(appealsDetails?.student_appeal?.appeal_status=="Declined" || appealsDetails?.student_appeal?.appeal_outcome == 1) ? <></> :
                        <div className="col-md-12">
                          <div className="form-group-blk">
                            <li>
                              <span className="title ">
                                Extended assessment date :
                              </span>
                              <span className="form-group-blk w-100">
                                <DatePicker
                                  disabled={!(appealsDetails?.student_appeal?.appeal_status != 'Approved' && appealsDetails?.student_appeal?.appeal_status != 'Declined')}
                                  selected={startDate}
                                  onChange={(date) => {
                                    setStartDate(date);
                                  }}
                                  minDate={new Date()}
                                  className="form-control w-100"
                                  showTimeSelect
                                  dateFormat={FORM_DATE_TIME_FORMAT}
                                />
                              </span>
                            </li>
                          </div>
                        </div>
                      }
                    </div>
                  </ul>
                </div>
              </div>
            ]
          },
        ]}
        bottomButton={appealsDetails?.student_appeal?.appeal_status && appealsDetails?.student_appeal?.appeal_status !== "Approved" && appealsDetails?.student_appeal?.appeal_status !== "Declined" ? [
          <button
            type="button"
            className="btn btn-success"
            title="Approve"
            onClick={() => handleSendResponse("Approve", appealsDetails.student?.student_id)}
            disabled={appealDisable === "Approve"}
          >
            {appealDisable === "Approve" ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-check"></i>}
            Approve
          </button>,
          <button
            type="button"
            className="btn btn-danger"
            title="Decline"
            onClick={() => handleSendResponse("Decline", appealsDetails.student?.student_id)}
            disabled={appealDisable === "Decline"}
          >
            {appealDisable === "Decline" ? <i className="fas fa-cog fa-spin"></i> : <i className="fal fa-times"></i>}
            Decline
          </button>
        ] : []}
        validationErrorMessage={[
          messageError
        ]}
      />
      
    </>
  );
}

export default React.memo(SubmissionAndResults);